import {
  CLEAR_AREA_CONTENT,
  CLEAR_DEPARTMENT_CONTENT,
  CLEAR_MANAGEMENT_CONTENT,
  CLEAR_SECTION_CONTENT,
  CLEAR_SPECIALITY_CONTENT,
  GET_AREA_CONTENT,
  GET_DEPARTMENT_CONTENT,
  GET_MANAGEMENT_CONTENT,
  GET_SECTION_CONTENT,
  GET_SPECIALITY_CONTENT,
} from '../actions/types';
import {
  SEARCH_STEP_PATH,
  PASSENGERS_STEP_PATH,
  PAYMENT_STEP_PATH,
  CONFIRMATION_STEP_PATH,
  POSTPAID_BOOKING_SEARCH_PATH,
  POSTPAID_BOOKING_PASSENGERS_PATH,
  POSTPAID_BOOKING_RECEIVER_PATH,
  POSTPAID_BOOKING_SUMMARY_PATH,
  MY_RESERVATIONS_SEARCH_STEP_PATH,
  MY_RESERVATIONS_CONFIRMATION_STEP_PATH,
  MY_RESERVATIONS_PASSENGERS_STEP_PATH,
  RIDE_BOOKING_SELECTION_SEAT_PATH,
  RIDE_BOOKING_SEARCH_PATH,
  RIDE_BOOKING_PASSENGERS_PATH,
  ROAD_BOOKING_SEARCH_PATH,
  ROAD_BOOKING_SELECTION_SEAT_PATH,
  ITINERARY_FOR_COUNTER_PATH,
  DRIVER_MOVEMENT_HISTORY_PATH,
} from './paths';

export const DEFAULT_SELECT_PLACEHOLDER = 'Seleccione...';
export const PEN_SYMBOL = 'S/';
export const USD_SYMBOL = '$';
export const KILOGRAM_SYMBOL = 'kg.';
export const KILOMETER_SYMBOL = 'km.';
export const MINUTE_SYMBOL = 'min.';
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_SORT = ['id,desc'];
export const DEFAULT_ORDER = 'desc';
export const MAX_DAYS_IN_REPORT = 120;
export const DATE_STRING_LENGTH = 10;
export const BUS_FLEET_BASE_LOCATION_IDS = [78, 76, 77, 579];
export const NUM_PASSENGERS_OPTIONS = [
  { value: null, label: 'Disponibles' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },
];
export const GENDERS = [
  { value: 'male', label: 'Masculino' },
  { value: 'female', label: 'Femenino' },
];

export const CREDIT_NOTE = 'CREDIT_NOTE';
export const VOUCHER_TYPE_BUSINESS_INVOICE_ID = 2;
export const VOUCHER_TYPE_INVOICE_ID = 1;
export const BUSINESS_INVOICE_ID = 2;

// transaction codes
export const TRANSACTION_TYPE_CREDIT_CARD = 'CREDIT_CARD';
export const TRANSACTION_TYPE_PAGO_EFECTIVO = 'PAGO_EFECTIVO';
export const TRANSACTION_TYPE_DELIVERY_CREDIT_CARD = 'DELIVERY_CREDIT_CARD';
export const TRANSACTION_TYPE_DELIVERY_CASH = 'DELIVERY_CASH';

export const PIN_PAD_TRANSACTION_SOURCE_TYPE = {
  TICKET: 'TICKET',
  PARCEL: 'PARCEL',
  EXCESS_BAGGAGE: 'EXCESS_BAGGAGE',
};

export const PIN_PAD_OPERATION = {
  SALE: 'SALE',
  VOID: 'VOID',
};

export const TRANSACTION_TYPE_BANK_TRANSFER = 'BANK_TRANSFER';
export const TRANSACTION_TYPE_BUSINESS_CREDIT = 'BUSINESS_CREDIT';
export const TRANSACTION_TYPE_CONTRACT = 'CONTRACT';
export const TRANSACTION_TYPE_NIUBIZ = 'NIUBIZ';
export const TRANSACTION_TYPE_OPENPAY_LINK = 'OPENPAY_LINK';
export const TRANSACTION_TYPE_CASH = 'CASH';
export const TRANSACTION_TYPE_INTERNET = 'INTERNET';
export const TRANSACTION_TYPE_OTHER = 'OTHER';
export const TRANSACTION_TYPE_CREDIT_NOTE = 'CREDIT_NOTE';
export const TRANSACTION_TYPE_PAYMENT_ON_ARRIVAL = 'PAYMENT_ON_ARRIVAL';
export const TRANSACTION_TYPE_FREE_OF_CHARGE = 'FREE_OF_CHARGE';

export const TRANSACTION_TYPE = {
  DEBIT: { value: 'DEBIT', label: 'DEBIT' },
  CREDIT: { value: 'CREDIT', label: 'CREDIT' },
};

export const getPaymentMethodNameByType = (code) => {
  switch (code) {
    case TRANSACTION_TYPE_CREDIT_CARD:
      return 'Tarjeta';
    case TRANSACTION_TYPE_PAGO_EFECTIVO:
      return 'Pago Efectivo';
    case TRANSACTION_TYPE_DELIVERY_CREDIT_CARD:
      return 'Tarjeta de Crédito (Entrega)';
    case TRANSACTION_TYPE_DELIVERY_CASH:
      return 'Efectivo (Entrega)';
    case TRANSACTION_TYPE_BANK_TRANSFER:
      return 'Deposito a Cuenta';
    case TRANSACTION_TYPE_BUSINESS_CREDIT:
      return 'Crédito Empresarial';
    case TRANSACTION_TYPE_NIUBIZ:
      return 'Niubiz';
    case TRANSACTION_TYPE_OPENPAY_LINK:
      return 'Openpay Link';
    case TRANSACTION_TYPE_CASH:
      return 'Contado';
    case TRANSACTION_TYPE_INTERNET:
      return 'Internet';
    case TRANSACTION_TYPE_OTHER:
      return 'Servicio a Título Gratuito';
    case TRANSACTION_TYPE_CREDIT_NOTE:
      return 'Anticipo';
    case TRANSACTION_TYPE_PAYMENT_ON_ARRIVAL:
      return 'Pago en Destino';
    case null:
      return 'ANULADOS';
    default:
      return 'Otro';
  }
};
// max page size due to restrictions with 32 bits
export const MAX_PAGE_SIZE = 2147483647;

export const CIVA_BOOKING_SEARCH_STEP_INDEX = 0;
export const CIVA_BOOKING_PASSENGERS_STEP_INDEX = 1;
export const CIVA_BOOKING_PAYMENT_STEP_INDEX = 2;
export const CIVA_BOOKING_CONFIRMATION_STEP_INDEX = 3;
export const CIVA_BOOKING_STEPS = [
  {
    title: 'Búsqueda',
    path: SEARCH_STEP_PATH,
    statePropertyName: 'search',
  },
  {
    title: 'Pasajeros',
    path: PASSENGERS_STEP_PATH,
    statePropertyName: 'passengers',
  },
  {
    title: 'Pago',
    path: PAYMENT_STEP_PATH,
    statePropertyName: 'payment',
  },
  {
    title: 'Confirmación',
    path: CONFIRMATION_STEP_PATH,
    statePropertyName: 'confirmation',
  },
];

export const CIVA_SALES_ON_ROUTE_BOOKING_STEPS = [
  {
    title: 'Búsqueda',
    path: RIDE_BOOKING_SEARCH_PATH,
    statePropertyName: 'search',
  },
  {
    title: 'Selección de Asientos',
    path: RIDE_BOOKING_SELECTION_SEAT_PATH,
    statePropertyName: 'seatSelection',
  },
  {
    title: 'Pasajeros / Pago',
    path: RIDE_BOOKING_PASSENGERS_PATH,
    statePropertyName: 'passengers',
  },
];

export const CIVA_SALES_ON_ROUTE_BOOKING_SEARCH_STEP_INDEX = 0;
export const CIVA_SALES_ON_ROUTE_BOOKING_SELECTION_SEAT_STEP_INDEX = 1;
export const CIVA_SALES_ON_ROUTE_BOOKING_PASSENGERS_STEP_INDEX = 2;

export const THIRD_PARTY_BOOKING_SEARCH_STEP_INDEX = 0;
export const THIRD_PARTY_PASSENGERS_STEP_INDEX = 1;
export const THIRD_PARTY_BOOKING_CONFIRMATION_STEP_INDEX = 2;
export const THIRD_PARTY_BOOKING_STEPS = [
  {
    title: 'Búsqueda',
    path: MY_RESERVATIONS_SEARCH_STEP_PATH,
    statePropertyName: 'search',
  },
  {
    title: 'Pasajeros',
    path: MY_RESERVATIONS_PASSENGERS_STEP_PATH,
    statePropertyName: 'passengers',
  },
  {
    title: 'Confirmación',
    path: MY_RESERVATIONS_CONFIRMATION_STEP_PATH,
    statePropertyName: 'confirmation',
  },
];

export const POSTPAID_BOOKING_SEARCH_STEP_INDEX = 0;
export const POSTPAID_BOOKING_PASSENGERS_STEP_INDEX = 1;
export const POSTPAID_BOOKING_RECEIVER_STEP_INDEX = 2;
export const POSTPAID_BOOKING_SUMMARY_STEP_INDEX = 3;
export const POSTPAID_BOOKING_STEPS = [
  {
    title: 'Búsqueda',
    path: POSTPAID_BOOKING_SEARCH_PATH,
    statePropertyName: 'search',
  },
  {
    title: 'Pasajeros',
    path: POSTPAID_BOOKING_PASSENGERS_PATH,
    statePropertyName: 'passengers',
  },
  {
    title: 'Destinatario',
    path: POSTPAID_BOOKING_RECEIVER_PATH,
    statePropertyName: 'receiver',
  },
  {
    title: 'Resumen',
    path: POSTPAID_BOOKING_SUMMARY_PATH,
    statePropertyName: 'summary',
  },
];

export const POSTPAID_BOOKING_PENDING = 0;
export const POSTPAID_BOOKING_APPROVED = 1;
export const POSTPAID_BOOKING_REJECTED = 2;

export const CIVA_ROAD_BOOKING_STEPS = [
  {
    title: 'Búsqueda',
    path: ROAD_BOOKING_SEARCH_PATH,
    statePropertyName: 'search',
  },
  {
    title: 'Selección de Asientos',
    path: ROAD_BOOKING_SELECTION_SEAT_PATH,
    statePropertyName: 'seatSelection',
  },
];

export const CIVA_ROAD_BOOKING_SEARCH_STEP_INDEX = 0;
export const CIVA_ROAD_BOOKING_SELECTION_SEAT_STEP_INDEX = 1;

export const ITINERARY_ACTIVE_OPTIONS = [
  {
    value: true,
    label: 'Activo',
  },
  {
    value: false,
    label: 'Inactivo',
  },
];

export const ROUTE_ACTIVE_OPTIONS = [
  {
    value: true,
    label: 'Activo',
  },
  {
    value: false,
    label: 'Inactivo',
  },
];

export const CIRCUIT_ACTIVE_OPTIONS = [
  {
    value: true,
    label: 'Activo',
  },
  {
    value: false,
    label: 'Inactivo',
  },
];

export const AGENCY_ACTIVE_OPTIONS = [
  {
    value: true,
    label: 'Activo',
  },
  {
    value: 'false,active:@',
    label: 'Inactivo',
  },
];

export const POSTPAID_BOOKING_STATUS_OPTIONS = [
  {
    value: 0,
    label: 'Pendiente',
  },
  {
    value: 1,
    label: 'Aprobado',
  },
  {
    value: 2,
    label: 'Rechazado',
  },
];

export const QUERY_DELIMITER = ',';

export const DEBOUNCE_WAIT_TIME = 400;

export const ITINERARY_TYPE_CONTRACT = 'Contract';

export const ITINERARY_TYPE_CONTRACTO = 'Contracto';

// ticket status

export const TICKET_ACTIVE = 0;
export const TICKET_VOIDED = 1;
export const TICKET_POSTPONED = 2;
export const TICKET_POSTPONED_DESC = 'Ticket postponed';

export const TICKET_REFUND = 'TICKET_REFUND';

export const DNI_ENUM_VALUE = 'DNI_LIBRETA_ELECTORAL';
export const PASAPORTE_ENUM_VALUE = 'PASAPORTE';
export const CARNET_EXTRANJERIA_ENUM_VALUE = 'CARNET_EXTRANJERIA';
export const OTROS_ENUM_VALUE = 'OTROS';

// regex
export const EMAIL_PATTERN =
  /^[-\w.+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
export const TICKET_PATTERN = /^[a-zA-z0-9]{1,}-?[0-9]{1,}$/;
export const DEPOSIT_FILE_TYPE_PATTERN =
  /(image|application)\/(jpg|jpeg|png|gif|pdf)$/;
export const EXCEL_FILE_PATTERN = /^(.*\.((xls|xlsx)$))[^.]*$/gim;
export const BILLING_DATE_PATTERN =
  /^(19[0-9]{2}|2[0-9]{3})-(0[1-9]|1[012])-([123]0|[012][1-9]|31)$/;
export const BILLING_TIME_PATTERN =
  /^(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])$/;

// regex ID number
export const DNI_PATTERN = /^\d{8}$/;
export const CARNET_EXTRANJERIA_PATTERN = /^[a-zA-Z0-9]{5,20}$/;
export const PASAPORTE_PATTERN = /^[a-zA-Z0-9]{1,12}$/;
export const OTROS_PATTERN = /^[a-zA-Z0-9]{1,15}$/;

// two step authorization
export const TWO_STEP_AUTHORIZATION = 'TWO_STEP_AUTHORIZATION';

// debounce time in milliseconds
export const CUSTOMER_SEARCH_DEBOUNCE = 275;

export const TICKET_STATUS = {
  ACTIVE: { value: 'ACTIVE', label: 'Activo', color: 'success' },
  IN_SALE_PROCESS: {
    value: 'IN_SALE_PROCESS',
    label: 'En proceso de venta',
    color: 'info',
  },
  VOIDED: { value: 'VOIDED', label: 'Anulado', color: 'danger' },
  POSTPONED: { value: 'POSTPONED', label: 'Postergado', color: 'warning' },
  CUSTOMER_CHANGE: {
    value: 'CUSTOMER_CHANGE',
    label: 'Cambio de pasajero',
    color: 'warning',
  },
  VOUCHER_TYPE_CHANGE: {
    value: 'VOUCHER_TYPE_CHANGE',
    label: 'Cambio de comprobante',
    color: 'warning',
  },
  REFUNDED: { value: 'REFUNDED', label: 'Devuelto', color: 'warning' },
  IN_POSTPONE_PROCESS: {
    value: 'IN_POSTPONE_PROCESS',
    label: 'En proceso de postergación',
    color: 'warning',
  },
};

export const TICKET_STATUS_OPTIONS = [
  {
    value: TICKET_STATUS.ACTIVE.value,
    label: TICKET_STATUS.ACTIVE.label,
  },
  {
    value: TICKET_STATUS.VOIDED.value,
    label: TICKET_STATUS.VOIDED.label,
  },
  {
    value: TICKET_STATUS.POSTPONED.value,
    label: TICKET_STATUS.POSTPONED.label,
  },
  {
    value: TICKET_STATUS.CUSTOMER_CHANGE.value,
    label: TICKET_STATUS.CUSTOMER_CHANGE.label,
  },
  {
    value: TICKET_STATUS.VOUCHER_TYPE_CHANGE.value,
    label: TICKET_STATUS.VOUCHER_TYPE_CHANGE.label,
  },
  {
    value: TICKET_STATUS.REFUNDED.value,
    label: TICKET_STATUS.REFUNDED.label,
  },
];

export const EXTRAORDINARY_MOVEMENT_CONTROL_STATUS = {
  PENDING: { value: 'PENDING', label: 'Pendiente', color: 'info' },
  ALERT: { value: 'ALERT', label: 'Alerta', color: 'warning' },
  AUTHORIZED: { value: 'AUTHORIZED', label: 'Autorizado', color: 'success' },
};

export const FUEL_VOUCHER_STATUS = {
  CREATED: { value: 'CREATED', label: 'Creado', color: 'info' },
  INVOICED: { value: 'INVOICED', label: 'Facturado', color: 'success' },
  INACTIVE: { value: 'INACTIVE', label: 'Inactivo', color: 'danger' },
};

export const FUEL_VOUCHER_EXTRAORDINARY_OPTIONS = [
  { value: true, label: 'Extraordinario' },
  { value: false, label: 'Regular' },
];

export const EXPENSE_TYPE_LABEL = {
  FUEL: { value: 'FUEL', label: 'Combustible' },
  DRIVER_COMMISSION: {
    value: 'DRIVER_COMMISSION',
    label: 'Comisión de Piloto',
  },
  CABIN_CREW_COMMISSION: {
    value: 'CABIN_CREW_COMMISSION',
    label: 'Comisión de Servicio a Bordo',
  },
  TOLL: { value: 'TOLL', label: 'Peaje' },
  OTHER: { value: 'OTHER', label: 'Otro' },
  TICKET_VOID: { value: 'TICKET_VOID', label: 'Anulación de Boleto' },
  TICKET_REFUND: { value: 'TICKET_REFUND', label: 'Devolución de Boleto' },
  EXCESS_BAGGAGE_VOID: {
    value: 'EXCESS_BAGGAGE_VOID',
    label: 'Anulación Exceso de Equipaje',
  },
  CASH_OUTFLOW: {
    value: 'CASH_OUTFLOW',
    label: 'Salida de Caja',
  },
  PARCEL_REFUND: {
    value: 'PARCEL_REFUND',
    label: 'Devolución de carga',
  },
  PARCEL_VOID: {
    value: 'PARCEL_VOID',
    label: 'Anulación de carga',
  },
  ADDITIONAL_ENTRY_FEE: {
    value: 'ADDITIONAL_ENTRY_FEE',
    label: 'Derecho de ingreso adicional',
  },
};

export const TRIP_STATUS = {
  scheduled: { value: 1, label: 'Programado' },
  departed: { value: 2, label: 'Partido' },
  arrived: { value: 3, label: 'Arribado' },
  deleted: { value: 4, label: 'Detenido' },
  diverted: { value: 5, label: 'Desviado' },
  cancelled: { value: 6, label: 'Cancelado' },
  transferred: { value: 7, label: 'Transferido' },
  terminated: { value: 8, label: 'Terminado' },
};

export const TRIP_STATUS_OPTIONS = [
  { value: TRIP_STATUS.departed.value, label: TRIP_STATUS.departed.label },
  { value: TRIP_STATUS.arrived.value, label: TRIP_STATUS.arrived.label },
];

export const ITINERARY_PRINT_BUTTON = {
  MANIFEST: { value: 'manifest', label: 'Manifiesto' },
  SEATING_CHART: { value: 'seating-chart', label: 'Croquis' },
  BAGGAGE_MANIFEST: { value: 'baggage-manifest', label: 'Manifiesto' },
  CARGO_MANIFEST: { value: 'cargo-manifest', label: 'Manifiesto' },
};

export const ITINERARY_PRINT_DROPDOWN_OPTIONS = [
  { value: 'header', label: 'Pasajeros' },
  { value: ITINERARY_PRINT_BUTTON.MANIFEST.value, label: 'Manifiesto' },
  { value: ITINERARY_PRINT_BUTTON.SEATING_CHART.value, label: 'Croquis' },
  { value: 'divider' },
  { value: 'header', label: 'Equipajes' },
  { value: ITINERARY_PRINT_BUTTON.BAGGAGE_MANIFEST.value, label: 'Manifiesto' },
  { value: 'header', label: 'Carga' },
  { value: ITINERARY_PRINT_BUTTON.CARGO_MANIFEST.value, label: 'Manifiesto' },
];

export const BAGGAGE_SEARCH_OPTIONS = [
  { value: 'ticketCode', label: 'Boleto de Viaje' },
  { value: 'excessCode', label: 'Boleta de Exceso' },
];

export const DEPRECIATION_TYPE = {
  ALL: { value: 'ALL', label: 'General' },
  CATEGORIZED: {
    value: 'CATEGORIZED',
    label: 'Por categorías',
  },
};

export const DEPRECIATION_PERIODICITY = {
  DAILY: { value: 'DAILY', label: 'Diaria' },
  MONTHLY: {
    value: 'MONTHLY',
    label: 'Mensual',
  },
  YEARLY: {
    value: 'YEARLY',
    label: 'Anual',
  },
};

export const PARCEL_STATUS = {
  RECEIVED: {
    value: 'RECEIVED',
    label: 'En agencia de origen',
  },
  DELIVERED: {
    value: 'DELIVERED',
    label: 'Entregado',
  },
  LOST: {
    value: 'LOST',
    label: 'Perdido',
  },
  UNCLAIMED_LOST: {
    value: 'UNCLAIMED_LOST',
    label: 'Abandono Legal - Perdido',
  },
  READY_FOR_PICKUP: {
    value: 'READY_FOR_PICKUP',
    label: 'Listo para Recoger',
  },
  IN_TRANSIT: {
    value: 'IN_TRANSIT',
    label: 'En Tránsito',
  },
};

export const PARCEL_FINANCIAL_STATUS = {
  REFUNDED: { value: 'REFUNDED', label: 'Devuelto', color: 'danger' },
  VOIDED: { value: 'VOIDED', label: 'Anulado', color: 'danger' },
  ACTIVE: { value: 'ACTIVE', label: 'Activo', color: 'success' },
};

export const BAGGAGE_ITEM_MOVEMENT_SEARCH_OPTIONS = [
  { value: 0, label: 'Itinerario' },
  { value: 1, label: 'Estado de item' },
  { value: 2, label: 'Boleto de viaje' },
  { value: 3, label: 'Item de equipaje' },
];

export const BAGGAGE_MOVEMENT_TYPE_OPTIONS = [
  { value: 0, label: 'Itinerario' },
  { value: 1, label: 'Agencia' },
];

export const BAGGAGE_ITEM_STATUS = {
  IN_ORIGIN_AGENCY: {
    value: 'IN_ORIGIN_AGENCY',
    label: 'En Agencia de Origen',
  },
  ON_ITINERARY: { value: 'ON_ITINERARY', label: 'En Itinerario' },
  AGENCY_STOP: { value: 'AGENCY_STOP', label: 'Agencia de Paso' },
  DELIVERED: { value: 'DELIVERED', label: 'Entregado' },
  NOT_ARRIVED: { value: 'NOT_ARRIVED', label: 'No Arribado' },
  CLOSED: { value: 'CLOSED', label: 'Cerrado' },
  VOIDED: { value: 'VOIDED', label: 'Anulado' },
};

export const BAGGAGE_ITEM_STATUS_OPTIONS = [
  {
    value: BAGGAGE_ITEM_STATUS.IN_ORIGIN_AGENCY.value,
    label: BAGGAGE_ITEM_STATUS.IN_ORIGIN_AGENCY.label,
  },
  {
    value: BAGGAGE_ITEM_STATUS.ON_ITINERARY.value,
    label: BAGGAGE_ITEM_STATUS.ON_ITINERARY.label,
  },
  {
    value: BAGGAGE_ITEM_STATUS.AGENCY_STOP.value,
    label: BAGGAGE_ITEM_STATUS.AGENCY_STOP.label,
  },
  {
    value: BAGGAGE_ITEM_STATUS.DELIVERED.value,
    label: BAGGAGE_ITEM_STATUS.DELIVERED.label,
  },
  {
    value: BAGGAGE_ITEM_STATUS.NOT_ARRIVED.value,
    label: BAGGAGE_ITEM_STATUS.NOT_ARRIVED.label,
  },
  {
    value: BAGGAGE_ITEM_STATUS.CLOSED.value,
    label: BAGGAGE_ITEM_STATUS.CLOSED.label,
  },
];

export const SPOT_IN_ITINERARY = {
  START: BAGGAGE_ITEM_STATUS.ON_ITINERARY,
  END: BAGGAGE_ITEM_STATUS.DELIVERED, // Before was BAGGAGE_ITEM_STATUS.ARRIBED but in the backend doesn't exist
  OTHER: BAGGAGE_ITEM_STATUS.AGENCY_STOP,
};

export const USER_ENABLED_OPTIONS = [
  {
    value: true,
    label: 'Activo',
  },
  {
    value: false,
    label: 'Inactivo',
  },
];

export const SECURITY_VISIBILITY = {
  INDIVIDUAL: { value: 'INDIVIDUAL', label: 'Individual' },
  AGENTIAL: { value: 'AGENTIAL', label: 'Agencial' },
  GLOBAL: { value: 'GLOBAL', label: 'Global' },
  NATIONAL: { value: 'NATIONAL', label: 'Nacional' },
  REGIONAL: { value: 'REGIONAL', label: 'Regional' },
  MUNICIPAL: { value: 'MUNICIPAL', label: 'Municipal' },
};

export const ITINERARY_REPEAT_TYPE = {
  NO_REPEAT: { value: 'NO_REPEAT', label: 'Ninguna', unit: '' },
  DAILY_REPEAT: { value: 'DAILY_REPEAT', label: 'Diario', unit: 'días' },
  WEEKLY_REPEAT: { value: 'WEEKLY_REPEAT', label: 'Semanal', unit: 'semanas' },
  MONTHLY_REPEAT: { value: 'MONTHLY_REPEAT', label: 'Mensual', unit: 'meses' },
  YEARLY_REPEAT: { value: 'YEARLY_REPEAT', label: 'Anual', unit: 'años' },
};

export const ITINERARY_REPEAT_TYPE_OPTIONS = [
  {
    value: ITINERARY_REPEAT_TYPE.NO_REPEAT.value,
    label: ITINERARY_REPEAT_TYPE.NO_REPEAT.label,
    unit: ITINERARY_REPEAT_TYPE.NO_REPEAT.unit,
  },
  {
    value: ITINERARY_REPEAT_TYPE.DAILY_REPEAT.value,
    label: ITINERARY_REPEAT_TYPE.DAILY_REPEAT.label,
    unit: ITINERARY_REPEAT_TYPE.DAILY_REPEAT.unit,
  },
  {
    value: ITINERARY_REPEAT_TYPE.WEEKLY_REPEAT.value,
    label: ITINERARY_REPEAT_TYPE.WEEKLY_REPEAT.label,
    unit: ITINERARY_REPEAT_TYPE.WEEKLY_REPEAT.unit,
  },
  {
    value: ITINERARY_REPEAT_TYPE.MONTHLY_REPEAT.value,
    label: ITINERARY_REPEAT_TYPE.MONTHLY_REPEAT.label,
    unit: ITINERARY_REPEAT_TYPE.MONTHLY_REPEAT.unit,
  },
  {
    value: ITINERARY_REPEAT_TYPE.YEARLY_REPEAT.value,
    label: ITINERARY_REPEAT_TYPE.YEARLY_REPEAT.label,
    unit: ITINERARY_REPEAT_TYPE.YEARLY_REPEAT.unit,
  },
];

export const ITINERARY_SCHEDULE_MACIVA_OPTIONS = [
  {
    value: true,
    label: 'Si',
  },
  {
    value: false,
    label: 'No',
  },
];

export const TRIP_CIRCUIT_STATUS = {
  START: { value: 'START', label: 'Inicio' },
  IN_PROGRESS: { value: 'IN_PROGRESS', label: 'En progreso' },
  END: { value: 'END', label: 'Fin' },
  UNKNOWN: { value: 'UNKNOWN', label: 'Desconocido' },
};

export const TRIP_CIRCUIT_STATUS_OPTIONS = [
  {
    value: TRIP_CIRCUIT_STATUS.START.value,
    label: TRIP_CIRCUIT_STATUS.START.label,
  },
  {
    value: TRIP_CIRCUIT_STATUS.IN_PROGRESS.value,
    label: TRIP_CIRCUIT_STATUS.IN_PROGRESS.label,
  },
  {
    value: TRIP_CIRCUIT_STATUS.END.value,
    label: TRIP_CIRCUIT_STATUS.END.label,
  },
  {
    value: TRIP_CIRCUIT_STATUS.UNKNOWN.value,
    label: TRIP_CIRCUIT_STATUS.UNKNOWN.label,
  },
];

export const CONTRACT_TYPE = {
  DEFAULT: { value: 'DEFAULT', label: 'Agencia Civa' },
  AE_AGENCY: { value: 'AE_AGENCY', label: 'Concesionario' },
  CORPORATE: { value: 'CORPORATE', label: 'Cliente Corporativo' },
  SELF_SERVICE: { value: 'SELF_SERVICE', label: 'Autoventa' },
  CASH_OUTFLOW: { value: 'CASH_OUTFLOW', label: 'Salida de Caja' },
  ECOMMERCE: { value: 'ECOMMERCE', label: 'Comercio Digital' },
  CONTACT_CENTER: { value: 'CONTACT_CENTER', label: 'Contact Center' },
  DIGITAL_ALIANCE: { value: 'DIGITAL_ALIANCE', label: 'Aliados Digitales' },
  AGENCIES: { value: 'AGENCIES', label: 'Agencias' },
  OWN_DEALERSHIPS: {
    value: 'OWN_DEALERSHIPS',
    label: 'Concesionarios Propios',
  },
  THIRD_PARTY_DEALERSHIPS: {
    value: 'THIRD_PARTY_DEALERSHIPS',
    label: 'Concesionarios Terceros',
  },
  CORPORATE_TICKETS: {
    value: 'CORPORATE_TICKETS',
    label: 'Corporativos Pasajes',
  },
  CORPORATE_CARGO: { value: 'CORPORATE_CARGO', label: 'Corporativos Carga' },
  PROJECTS: { value: 'PROJECTS', label: 'Proyectos' },
  ADMINISTRATIVE: { value: 'ADMINISTRATIVE', label: 'Administrativos' },
  MAINTENANCE_DEPOTS: { value: 'MAINTENANCE_DEPOTS', label: 'Bases Taller' },
  NON_COMMERCIAL: { value: 'NON_COMMERCIAL', label: 'No comerciales' },
  OTHERS: { value: 'OTHERS', label: 'Otros' },
};

export const BBVA_BANK_ID = 1;

export const DEPOSIT_TYPE = {
  DEFAULT: { value: 'DEFAULT', label: 'Por defecto' },
  DETRACCION: { value: 'DETRACCION', label: 'Detracción' },
  COMMISSION: { value: 'COMMISSION', label: 'Comisión' },
};

export const DEPOSIT_TYPE_OPTIONS = [
  {
    value: DEPOSIT_TYPE.DETRACCION.value,
    label: DEPOSIT_TYPE.DETRACCION.label,
  },
  {
    value: DEPOSIT_TYPE.COMMISSION.value,
    label: DEPOSIT_TYPE.COMMISSION.label,
  },
];

export const BANK_RECONCILIATION_STATUS = {
  RECONCILED: { value: 'RECONCILED', label: 'Conciliada', color: 'success' },
  PARTIAL: { value: 'PARTIAL', label: 'Parcial', color: 'warning' },
  UNRECONCILED: {
    value: 'UNRECONCILED',
    label: 'Sin conciliar',
    color: 'danger',
  },
};

export const BANK_RECONCILIATION_STATUS_BACKGROUND = {
  RECONCILED: '#eaf7ec',
  PARTIAL: '#fff8e1',
  UNRECONCILED: '#fdecea',
};

export const BANK_RECONCILIATION_HOLDER_TYPE = {
  BUSINESS: { value: 'BUSINESS', label: 'Empresa', color: 'info' },
  CUSTOMER: { value: 'CUSTOMER', label: 'Persona', color: 'secondary' },
};

export const BANK_RECONCILIATION_DEPOSIT_RESULT = {
  MATCHED: { value: 'MATCHED', label: 'Coincide', color: 'success' },
  PARTIAL_MATCH: {
    value: 'PARTIAL_MATCH',
    label: 'Coincide parcial',
    color: 'warning',
  },
  UNMATCHED: { value: 'UNMATCHED', label: 'Sin match', color: 'danger' },
  DIRECT_VALIDATED: {
    value: 'DIRECT_VALIDATED',
    label: 'Validado directo',
    color: 'info',
  },
  LEGACY: { value: 'LEGACY', label: 'Previo al módulo', color: 'secondary' },
};

export const BANK_RECONCILIATION_DEPOSIT_ROW_BACKGROUND = {
  MATCHED: '#eaf7ec',
  DIRECT_VALIDATED: '#eaf7ec',
  PARTIAL_MATCH: '#fff8e1',
  UNMATCHED: '#fdecea',
};

export const DEPOSIT_MIGRATION_STATUS = {
  LEGACY: { value: 'LEGACY', label: 'Histórico', color: 'secondary' },
  PENDING_MIGRATION: {
    value: 'PENDING_MIGRATION',
    label: 'Pendiente de envío',
    color: 'warning',
  },
  PENDING_BANK_FILE: {
    value: 'PENDING_BANK_FILE',
    label: 'Esperando estado de cuenta',
    color: 'info',
  },
  NOT_APPLICABLE: {
    value: 'NOT_APPLICABLE',
    label: 'No corresponde',
    color: 'secondary',
  },
  MIGRATED: { value: 'MIGRATED', label: 'Migrado', color: 'success' },
  FAILED: { value: 'FAILED', label: 'Falló', color: 'danger' },
};

export const DEPOSIT_BANK_TRANSFER_STATUS = {
  PENDING_BANK_VERIFICATION: {
    value: 'PENDING_BANK_VERIFICATION',
    label: 'Esperando confirmación del banco',
    color: 'info',
  },
  PENDING_MIGRATION: {
    value: 'PENDING_MIGRATION',
    label: 'Pendiente de envío',
    color: 'warning',
  },
  MIGRATED: { value: 'MIGRATED', label: 'Migrado', color: 'success' },
  FAILED: { value: 'FAILED', label: 'Falló', color: 'danger' },
};

export const SAP_MIGRATION_DOCUMENT_TYPE = {
  BANK_TRANSFER: { value: 'BANK_TRANSFER', label: 'Transferencia' },
};

export const DEPOSIT_MIGRATION_FILE_STATUS = {
  PROCESSED: { value: 'PROCESSED', label: 'Procesada', color: 'success' },
  WITH_OBSERVATIONS: {
    value: 'WITH_OBSERVATIONS',
    label: 'Con observaciones',
    color: 'warning',
  },
  FAILED: { value: 'FAILED', label: 'Falló', color: 'danger' },
  VOIDED: { value: 'VOIDED', label: 'Anulada', color: 'secondary' },
};

export const DEPOSIT_MIGRATION_MOVEMENT_CLASSIFICATION = {
  PROCESSED: { value: 'PROCESSED', label: 'Procesados', color: 'success' },
  PARTIAL_MATCH: {
    value: 'PARTIAL_MATCH',
    label: 'Coincide parcial',
    color: 'warning',
  },
  UNMATCHED: { value: 'UNMATCHED', label: 'Sin match', color: 'danger' },
  DISCARDED: { value: 'DISCARDED', label: 'Descartados', color: 'secondary' },
};

export const DEPOSIT_MIGRATION_MOVEMENT_ROW_BACKGROUND = {
  PROCESSED: '#eaf7ec',
  PARTIAL_MATCH: '#fff8e1',
  UNMATCHED: '#fdecea',
};

export const DEPOSIT_MIGRATION_BANK = {
  BCP: { value: 2, label: 'BCP', color: 'primary' },
  PICHINCHA: { value: 3, label: 'Pichincha', color: 'info' },
};

export const DEPOSIT_MIGRATION_MAX_FILE_SIZE = 10 * 1024 * 1024;

export const DEPOSIT_EDIT_HISTORY_FIELD_LABEL = {
  actualAmountDeposited: 'Monto depositado',
  depositDate: 'Fecha de depósito',
  operationNumber: 'Número de operación',
  bankAccountId: 'Cuenta bancaria',
  depositBankAccount: 'Se agregó / se quitó una cuenta',
};

export const COMPANY_TYPE = {
  CIVA: { value: 'CIVA', label: 'Civa' },
  OTHER: { value: 'OTHER', label: 'Otros' },
};

export const COMPANY_TYPE_OPTIONS = [
  {
    value: COMPANY_TYPE.CIVA.value,
    label: COMPANY_TYPE.CIVA.label,
  },
  {
    value: COMPANY_TYPE.OTHER.value,
    label: COMPANY_TYPE.OTHER.label,
  },
];

export const ITINERARY_SCHEDULE_EDIT_BUTTON = {
  ITINERARY_SCHEDULE_EDIT: {
    value: 'itinerary-schedule-edit',
    label: 'Plantilla',
  },
  ITINERARY_STATUSSES_EDIT: {
    value: 'itinerary-statusses-edit',
    label: 'Estado de Itinerarios',
  },
};

export const ITINERARY_SCHEDULE_EDIT_DROPDOWN_OPTIONS = [
  {
    value: ITINERARY_SCHEDULE_EDIT_BUTTON.ITINERARY_SCHEDULE_EDIT.value,
    label: ITINERARY_SCHEDULE_EDIT_BUTTON.ITINERARY_SCHEDULE_EDIT.label,
  },
  { value: 'divider' },
  {
    value: ITINERARY_SCHEDULE_EDIT_BUTTON.ITINERARY_STATUSSES_EDIT.value,
    label: ITINERARY_SCHEDULE_EDIT_BUTTON.ITINERARY_STATUSSES_EDIT.label,
  },
];

export const EXTRAORDINARY_MOVEMENT_TYPE = {
  TRANSFER: { value: 'TRANSFER', label: 'Transferido' },
  CONTRACT: { value: 'CONTRACT', label: 'Contrato' },
  SERVICE_REPLACE: { value: 'SERVICE_REPLACE', label: 'Reemplazo' },
  MAINTENANCE_TEST: { value: 'MAINTENANCE_TEST', label: 'Mantenimiento' },
  TRAFFIC: { value: 'TRAFFIC', label: 'Tráfico' },
  PARCEL: { value: 'PARCEL', label: 'Pasajes y Cargo' },
  AUTHORIZED_BY_MANAGMENT: {
    value: 'AUTHORIZED_BY_MANAGMENT',
    label: 'Autorizado por Gerencia',
  },
  OTHER: { value: 'OTHER', label: 'Otros' },
};

export const EXTRAORDINARY_MOVEMENT_TYPE_OPTIONS = [
  {
    value: EXTRAORDINARY_MOVEMENT_TYPE.TRANSFER.value,
    label: EXTRAORDINARY_MOVEMENT_TYPE.TRANSFER.label,
  },
  {
    value: EXTRAORDINARY_MOVEMENT_TYPE.SERVICE_REPLACE.value,
    label: EXTRAORDINARY_MOVEMENT_TYPE.SERVICE_REPLACE.label,
  },
  {
    value: EXTRAORDINARY_MOVEMENT_TYPE.CONTRACT.value,
    label: EXTRAORDINARY_MOVEMENT_TYPE.CONTRACT.label,
  },
  {
    value: EXTRAORDINARY_MOVEMENT_TYPE.MAINTENANCE_TEST.value,
    label: EXTRAORDINARY_MOVEMENT_TYPE.MAINTENANCE_TEST.label,
  },
  {
    value: EXTRAORDINARY_MOVEMENT_TYPE.TRAFFIC.value,
    label: EXTRAORDINARY_MOVEMENT_TYPE.TRAFFIC.label,
  },
  {
    value: EXTRAORDINARY_MOVEMENT_TYPE.PARCEL.value,
    label: EXTRAORDINARY_MOVEMENT_TYPE.PARCEL.label,
  },
  {
    value: EXTRAORDINARY_MOVEMENT_TYPE.AUTHORIZED_BY_MANAGMENT.value,
    label: EXTRAORDINARY_MOVEMENT_TYPE.AUTHORIZED_BY_MANAGMENT.label,
  },
  {
    value: EXTRAORDINARY_MOVEMENT_TYPE.OTHER.value,
    label: EXTRAORDINARY_MOVEMENT_TYPE.OTHER.label,
  },
];

export const ITINERARY_TYPE = {
  regular: { value: 'regular', label: 'Regular' },
  adicional: { value: 'adicional', label: 'Adicional' },
  contrato: { value: 'contrato', label: 'Contrato' },
  contract: { value: 'contract', label: 'Contrato' },
  parcel: { value: 'parcel', label: 'Cargo' },
  cargo: { value: 'Cargo', label: 'Cargo' }, // TODO remove this when backend has been estandardized
  maintenance: { value: 'maintenance', label: 'Mantenimiento' },
  extraordinario: { value: 'extraordinario', label: 'Extraordinario' },
};

export const ITINERARY_TYPE_OPTIONS = [
  {
    value: ITINERARY_TYPE.regular.value,
    label: ITINERARY_TYPE.regular.label,
  },
  {
    value: ITINERARY_TYPE.adicional.value,
    label: ITINERARY_TYPE.adicional.label,
  },
  {
    value: ITINERARY_TYPE.contrato.value,
    label: ITINERARY_TYPE.contrato.label,
  },
  {
    value: ITINERARY_TYPE.parcel.value,
    label: ITINERARY_TYPE.parcel.label,
  },
  {
    value: ITINERARY_TYPE.maintenance.value,
    label: ITINERARY_TYPE.maintenance.label,
  },
];

export const ITINERARY_TYPE_SEARCH_OPTIONS = [
  { value: '', label: 'Todos' },
  {
    value: ITINERARY_TYPE.regular.value,
    label: ITINERARY_TYPE.regular.label,
  },
  {
    value: ITINERARY_TYPE.adicional.value,
    label: ITINERARY_TYPE.adicional.label,
  },
];

export const ITINERARY_STATUS_SEARCH_OPTIONS = [
  { value: true, label: 'Itinerario programado' },
  { value: false, label: 'Itinerario no programado' },
];

export const PURCHASE_ORDER_STATUS = {
  CREATED: { value: 'CREATED', label: 'Creado', color: 'warning' },
  APPROVED: { value: 'APPROVED', label: 'Aprobado', color: 'success' },
  REJECTED: { value: 'REJECTED', label: 'Rechazado', color: 'danger' },
};

export const PURCHASE_ORDER_STATUS_OPTIONS = [
  {
    value: PURCHASE_ORDER_STATUS.CREATED.value,
    label: PURCHASE_ORDER_STATUS.CREATED.label,
  },
  {
    value: PURCHASE_ORDER_STATUS.APPROVED.value,
    label: PURCHASE_ORDER_STATUS.APPROVED.label,
  },
  {
    value: PURCHASE_ORDER_STATUS.REJECTED.value,
    label: PURCHASE_ORDER_STATUS.REJECTED.label,
  },
];

export const IN_SYSTEM_NOTIFICATION_SEVERITY = {
  PRIMARY: { value: 'PRIMARY', label: 'Primary' },
  SECONDARY: { value: 'SECONDARY', label: 'Secondary' },
  SUCCESS: { value: 'SUCCESS', label: 'Success' },
  DANGER: { value: 'DANGER', label: 'Danger' },
  WARNING: { value: 'WARNING', label: 'Warning' },
  INFO: { value: 'INFO', label: 'Info' },
  LIGHT: { value: 'LIGHT', label: 'Light' },
  DARK: { value: 'DARK', label: 'Dark' },
};

export const MAX_SIZE_ENABLED_TO_UPLOAD = 2097152; // 2mb

export const EXPENSE_STATUS = {
  APPROVED: { value: 'APPROVED', label: 'Aprobado' },
  REJECTED: { value: 'REJECTED', label: 'Rechazado' },
  PENDING: { value: 'PENDING', label: 'Pendiente' },
  SOLVED: { value: 'SOLVED', label: 'Solucionado' },
  PRE_APPROVED: { value: 'PRE_APPROVED', label: 'Pre-Aprobado' },
};

export const ITINERARY_GROUP_STATUS = {
  CREATED: { value: 'CREATED', label: 'Creado' },
  CONFIRMED: { value: 'CONFIRMED', label: 'Confirmado' },
};

export const COLOR = {
  success: '#dff0d8',
  info: '#d9edf7',
  warning: '#fcf8e3',
  danger: '#f2dede',
  selectedRow: '#fff3cd',
  lightGray: '#d9d9d9',
  darkGray: '#696969',
  black: '#000000',
  white: '#ffffff',
  orange: '#fad6aa',
  skyBlue: '#4682B4',
  green: '#00A36C',
  red: '#FF0000',
};

export const CONTRACT_MOVEMENT_TYPE = {
  REGULAR: { value: 'REGULAR', label: 'Contrato Regular' },
  NON_REGULAR: { value: 'NON_REGULAR', label: 'Contrato No Regular' },
  LOCAL: { value: 'LOCAL', label: 'Contrato Local' },
};

export const CONTRACT_STATUS = {
  ACEPTED: { value: 'ACEPTED', label: 'Aceptado', color: 'warning' },
  IN_PROGRESS: { value: 'IN_PROGRESS', label: 'En progreso', color: 'info' },
  DONE: { value: 'DONE', label: 'Terminado', color: 'primary' },
  PAID: { value: 'PAID', label: 'Pagado', color: 'success' },
};

export const CONTRACT_DOCUMENT_TYPE = {
  FACTURA: { value: 'FACTURA', label: 'Boletos Facturados' },
  BOLETA_INTERNA: {
    value: 'BOLETA_INTERNA',
    label: 'Boletos con Valor Contable',
  },
  FACTURA_INTERNA: {
    value: 'FACTURA_INTERNA',
    label: 'Boletos Facturados sin Valor Contable',
  },
};

export const CREDIT_NOTE_STATUS_OPTIONS = [
  {
    value: true,
    label: 'Activo',
  },
  {
    value: false,
    label: 'Inactivo',
  },
];

export const MANUAL_VOUCHER_PAYMENT_TYPE = {
  CASH: { value: 'CASH', label: 'Contado' },
  CREDIT: { value: 'CREDIT', label: 'Crédito' },
};

export const CURRENCY_CODE = {
  PEN: { value: 'PEN', label: 'Soles', symbol: PEN_SYMBOL },
  USD: { value: 'USD', label: 'Dólares', symbol: USD_SYMBOL },
};

export const MANUAL_VOUCHER_SERVICE_TYPE = {
  TICKET_SERVICE: { value: 'TICKET_SERVICE', label: 'Pasajes' },
  PARCEL: { value: 'PARCEL', label: 'Cargo' },
  CONTRACT: { value: 'CONTRACT', label: 'Contratos' },
  MINE: { value: 'MINE', label: 'Mina' },
  CORPORATE: { value: 'CORPORATE', label: 'Corporativo' },
  AE_AGENCY: { value: 'AE_AGENCY', label: 'Agencia de viajes' },
  EXCESS_BAGGAGE: { value: 'EXCESS_BAGGAGE', label: 'Exceso de equipaje' },
  RENT: { value: 'RENT', label: 'Alquiler' },
  OTHER: { value: 'OTHER', label: 'Otros' },
  MINE_ADDITIONAL_SERVICE: {
    value: 'MINE_ADDITIONAL_SERVICE',
    label: 'Servicio adicional mina',
  },
};

export const SUNAT_INVOICE_CODE = '01';
export const SUNAT_TICKET_CODE = '03';
export const SUNAT_CREDIT_NOTE_CODE = '07';
export const SUNAT_DEBIT_NOTE_CODE = '08';

export const SUNAT_VOUCHER_TYPES = {
  '01': { value: '01', label: 'Factura' },
  '03': { value: '03', label: 'Boleta de Venta' },
  '07': { value: '07', label: 'Nota de Crédito' },
  '08': { value: '08', label: 'Nota de Débito' },
};

export const ORGANIZATION_CHART_AREA_TYPES = {
  management: {
    id: 1,
    name: 'management',
    get: GET_MANAGEMENT_CONTENT,
    clear: CLEAR_MANAGEMENT_CONTENT,
  },
  department: {
    id: 2,
    name: 'department',
    parent: 'management',
    get: GET_DEPARTMENT_CONTENT,
    clear: CLEAR_DEPARTMENT_CONTENT,
  },
  area: {
    id: 3,
    name: 'area',
    parent: 'department',
    get: GET_AREA_CONTENT,
    clear: CLEAR_AREA_CONTENT,
  },
  section: {
    id: 4,
    name: 'section',
    parent: 'area',
    get: GET_SECTION_CONTENT,
    clear: CLEAR_SECTION_CONTENT,
  },
  speciality: {
    id: 5,
    name: 'speciality',
    parent: 'section',
    get: GET_SPECIALITY_CONTENT,
    clear: CLEAR_SPECIALITY_CONTENT,
  },
};

export const MAINTENANCE_FACTOR_TYPE = {
  KILOMETER: { value: 'KILOMETER', label: 'Kilómetros' },
  DAY: { value: 'DAY', label: 'Días' },
};

export const MAINTENANCE_PLANNING_TYPE = {
  LINEAL: { value: 'LINEAL', label: 'Líneal' },
  CICLICAL: { value: 'CICLICAL', label: 'Ciclico' },
};

export const ACTIVITY_STATUS = {
  PENDING: { value: 'PENDING', label: 'Pendiente', color: 'info' },
  EXTENDED: { value: 'EXTENDED', label: 'Extendido', color: 'warning' },
  DONE: { value: 'DONE', label: 'Realizado', color: 'success' },
  ADVANCE: { value: 'ADVANCE', label: 'Adelantado', color: 'primary' },
  IN_PROGRESS: { value: 'IN_PROGRESS', label: 'En progreso', color: 'info' },
  DEFAULT: { value: 'DEFAULT', label: 'Por defecto', color: 'secondary' },
  OPEN: { value: 'OPEN', label: 'Abierto', color: 'error' },
};

export const CIP_DOCUMENT_TYPE = {
  DNI: { value: 'DNI', label: 'DNI' },
  PAR: { value: 'PAR', label: 'Partida' },
  PAS: { value: 'PAS', label: 'Pasaporte' },
  LMI: { value: 'LMI', label: 'Libreta Militar' },
  NAN: { value: 'NAN', label: 'Otros' },
};

export const NIUBIZ_DOCUMENT_TYPE = {
  DNI: { value: 'NATIONAL_ID', label: 'DNI' },
  PAS: { value: 'PASSPORT', label: 'PASAPORTE' },
  CE: { value: 'RESIDENT_ID', label: 'C.E.' },
};

export const REGISTER_OF_EXECUTION_TYPE = {
  false: { value: false, label: 'Preventivo', color: 'primary' },
  true: { value: true, label: 'Adelantado', color: 'danger' },
};

export const MATERIAL_MEASUREMENT_UNIT = [
  'MAN',
  'GAL',
  'UND',
  'MTS',
  'KGR',
  'PZA',
  'LTS',
  'JGO',
  'CTO',
  'CAJA',
  'CIENTO',
  'MIL',
  'PQTE',
  'TAL',
  'BIDON',
  'PAR',
  'BAL',
  'MTS3',
];

export const RELATIONSHIP = {
  MOTHER: { value: 'MOTHER', label: 'Mamá' },
  FATHER: { value: 'FATHER', label: 'Papá' },
  UNCLE: { value: 'UNCLE', label: 'Tío(a)' },
  GRANDFATHER: { value: 'GRANDFATHER', label: 'Abuelo(a)' },
  SIBLING: { value: 'SIBLING', label: 'Hermano(a)' },
  COUSIN: { value: 'COUSIN', label: 'Primo(a)' },
  OTHER: { value: 'OTHER', label: 'Otro' },
};

export const RELATIONSHIP_TO_MINOR = {
  MOTHER: { value: 'MOTHER', label: 'Mamá' },
  FATHER: { value: 'FATHER', label: 'Papá' },
  UNCLE: { value: 'UNCLE', label: 'Tío(a)' },
  GRANDFATHER: { value: 'GRANDFATHER', label: 'Abuelo(a)' },
  SIBLING: { value: 'SIBLING', label: 'Hermano(a)' },
  COUSIN: { value: 'COUSIN', label: 'Primo(a)' },
  TRAVELS_ALONE: { value: 'TRAVELS_ALONE', label: 'Viaja solo' },
  OTHER: { value: 'OTHER', label: 'Otro' },
};

export const RELATIONSHIP_WITH_PERMIT = {
  UNCLE: { value: 'UNCLE', label: 'Tío(a)' },
  GRANDFATHER: { value: 'GRANDFATHER', label: 'Abuelo(a)' },
  SIBLING: { value: 'SIBLING', label: 'Hermano(a)' },
  COUSIN: { value: 'COUSIN', label: 'Primo(a)' },
  TRAVELS_ALONE: { value: 'TRAVELS_ALONE', label: 'Viaja solo' },
  OTHER: { value: 'OTHER', label: 'Otro' },
};

export const AGE_TYPES = {
  MONTHS: { value: 'MONTHS', label: 'Meses' },
  YEARS: { value: 'YEARS', label: 'Años' },
  DAYS: { value: 'DAYS', label: 'Días' },
};

export const BILLING_PROCESS_TYPE = {
  GUIA_REMISION_TRANSPORTISTA: {
    value: 'GUIA_REMISION_TRANSPORTISTA',
    label: 'Guía de Remisión Transportista',
    color: 'info',
  },
  GUIA_REMISION_REMITENTE: {
    value: 'GUIA_REMISION_REMITENTE',
    label: 'Guía de Remisión Remitente',
    color: 'primary',
  },
  BOLETA: {
    value: 'BOLETA',
    label: 'Boleta',
    color: 'success',
  },
  FACTURA: {
    value: 'FACTURA',
    label: 'Factura',
    color: 'warning',
  },
  NOTA_CREDITO: {
    value: 'NOTA_CREDITO',
    label: 'Nota de Crédito',
    color: 'secondary',
  },
  RETENCION: {
    value: 'RETENCION',
    label: 'Retención',
    color: 'light',
  },
  REVERSION: {
    value: 'REVERSION',
    label: 'Reversión',
    color: 'danger',
  },
};

export const BILLING_PROCESS_STATUS = {
  READY_FOR_PROCESS: {
    value: 'READY_FOR_PROCESS',
    label: 'Listo para procesar',
    color: 'info',
  },
  PROCESSED: {
    value: 'PROCESSED',
    label: 'Procesado',
    color: 'success',
  },
  ERROR: {
    value: 'ERROR',
    label: 'Error',
    color: 'danger',
  },
  IN_PROGRESS: {
    value: 'IN_PROGRESS',
    label: 'En progreso',
    color: 'warning',
  },
  READY_FOR_TICKET: {
    value: 'READY_FOR_TICKET',
    label: 'Listo para ticket',
    color: 'primary',
  },
  TICKET_IN_PROGRESS: {
    value: 'TICKET_IN_PROGRESS',
    label: 'Ticket en progreso',
    color: 'secondary',
  },
  CDR_IN_PROGRESS: {
    value: 'CDR_IN_PROGRESS',
    label: 'CDR en progreso',
    color: 'warning',
  },
};

export const BILLING_PROCESS_REPORT_STATUS = {
  PROCESSED: {
    value: 'PROCESSED',
    label: 'Informado',
    color: 'success',
  },
  ERROR: {
    value: 'ERROR',
    label: 'Error',
    color: 'danger',
  },
  IN_PROGRESS: {
    value: 'IN_PROGRESS',
    label: 'En progreso',
    color: 'warning',
  },
};

export const BILLING_DOCUMENT_TYPE = {
  DOC_TRIB_NO_DOM_SIN_RUC: {
    value: 'DOC_TRIB_NO_DOM_SIN_RUC',
    label: 'OTROS TIPOS DE DOCUMENTOS',
  },
  DNI: { value: 'DNI', label: 'DNI' },
  CARNET_EXTRANJERIA: {
    value: 'CARNET_EXTRANJERIA',
    label: 'CARNET DE EXTRANJERIA',
  },
  RUC: { value: 'RUC', label: 'RUC' },
  PASAPORTE: { value: 'PASAPORTE', label: 'PASAPORTE' },
};

export const BILLING_VOUCHER_TYPE = {
  FACTURA: { value: 'FACTURA', label: 'FACTURA' },
  BOLETA_DE_VENTA: {
    value: 'BOLETA_DE_VENTA',
    label: 'BOLETA DE VENTA',
  },
  LIQUIDACION_DE_COMPRA: {
    value: 'LIQUIDACION_DE_COMPRA',
    label: 'LIQUIDACION DE COMPRA',
  },
  BOLETOS_TRANSPORTE_AEREO: {
    value: 'BOLETOS_TRANSPORTE_AEREO',
    label: 'BOLETOS TRANSPORTE AEREO',
  },
  CARTA_PORTE_AEREO: { value: 'CARTA_PORTE_AEREO', label: 'CARTA PORTE AEREO' },
  NOTA_DE_CREDITO: { value: 'NOTA_DE_CREDITO', label: 'NOTA DE CREDITO' },
  BOLETA_DE_VIAJE: { value: 'BOLETA_DE_VIAJE', label: 'BOLETA DE VIAJE' },
};

export const MAINTENANCE_ACTIVITY_TYPE = {
  PREVENTIVE: { value: 'PREVENTIVE', label: 'Preventivo' },
  CORRECTIVE: { value: 'CORRECTIVE', label: 'Correctivo' },
  CAMPAIGN: { value: 'CAMPAIGN', label: 'Campaña' },
};

export const ENDPOINT_PERMISSION_TYPE = {
  NONE: { value: 'NONE', label: 'NONE' },
  READ: { value: 'READ', label: 'READ' },
  WRITE: { value: 'WRITE', label: 'WRITE' },
};

export const GENERAL_INCOME_TYPE_LABEL = {
  TAXABLE: { value: 'TAXABLE', label: 'TAXABLE' },
  NOT_TAXABLE: { value: 'NOT_TAXABLE', label: 'NOT_TAXABLE' },
  CREDIT_NOTE_EXCESS: {
    value: 'CREDIT_NOTE_EXCESS',
    label: 'CREDIT_NOTE_EXCESS',
  },
  PETTY_CASH_RETURN: {
    value: 'PETTY_CASH_RETURN',
    label: 'PETTY_CASH_RETURN',
  },
};

export const TRANSACTION_CODE = {
  CASH: { value: 'CASH', label: 'CASH' },
  CREDIT_CARD: { value: 'CREDIT_CARD', label: 'CREDIT_CARD' },
  INTERNET: { value: 'INTERNET', label: 'INTERNET' },
  TOLL: { value: 'TOLL', label: 'TOLL' },
  COMMISSION: { value: 'COMMISSION', label: 'COMMISSION' },
  WIRE: { value: 'WIRE', label: 'WIRE' },
  OTHER: { value: 'OTHER', label: 'OTHER' },
  CREDIT_NOTE: { value: 'CREDIT_NOTE', label: 'CREDIT_NOTE' },
  BUSINESS_CREDIT: { value: 'BUSINESS_CREDIT', label: 'BUSINESS_CREDIT' },
  ADVANCE_PAYMENT: { value: 'ADVANCE_PAYMENT', label: 'ADVANCE_PAYMENT' },
  PAGO_EFECTIVO: { value: 'PAGO_EFECTIVO', label: 'PAGO_EFECTIVO' },
  DELIVERY_CASH: { value: 'DELIVERY_CASH', label: 'DELIVERY_CASH' },
  DELIVERY_CREDIT_CARD: {
    value: 'DELIVERY_CREDIT_CARD',
    label: 'DELIVERY_CREDIT_CARD',
  },
  BANK_TRANSFER: { value: 'BANK_TRANSFER', label: 'BANK_TRANSFER' },
  CONTRACT: { value: 'CONTRACT', label: 'CONTRACT' },
  PAYMENT_ON_ARRIVAL: {
    value: 'PAYMENT_ON_ARRIVAL',
    label: 'PAYMENT_ON_ARRIVAL',
  },
  NIUBIZ: { value: 'NIUBIZ', label: 'NIUBIZ' },
  OPENPAY_LINK: { value: 'OPENPAY_LINK', label: 'OPENPAY_LINK' },
  FREE_OF_CHARGE: { value: 'FREE_OF_CHARGE', label: 'FREE_OF_CHARGE' },
};

export const MAINTENANCE_WARNING_TYPE = {
  FAIL: { value: 'FAIL', label: 'Falla' },
  WORK_REQUEST: { value: 'WORK_REQUEST', label: 'Solicitud de trabajo' },
  ROUTE_EVENT: { value: 'ROUTE_EVENT', label: 'Evento en ruta' },
  DRIVER_BUS_BODYWORK_INCIDENCE: {
    value: 'DRIVER_BUS_BODYWORK_INCIDENCE',
    label: 'Incidencia Carroceria Conductor',
  },
  TIRES_INCIDENCE: { value: 'TIRES_INCIDENCE', label: 'Incidencia Neumaticos' },
  MECHANICAL_INCIDENCE: {
    value: 'MECHANICAL_INCIDENCE',
    label: 'Incidencia Mecánica',
  },
  ELECTRICAL_INCIDENCE: {
    value: 'ELECTRICAL_INCIDENCE',
    label: 'Incidencia Electrica',
  },
};

export const MAINTENANCE_WARNING_PRIORITY = {
  LOW: {
    value: 'LOW',
    label: 'Baja',
    color: 'secondary',
    hexColor: COLOR.darkGray,
    icon: 'fa fa-level-down',
  },
  MEDIUM: {
    value: 'MEDIUM',
    label: 'Media',
    color: 'warning',
    hexColor: COLOR.warning,
    icon: 'fa fa-arrows-h',
  },
  HIGH: {
    value: 'HIGH',
    label: 'Alta',
    color: 'danger',
    hexColor: COLOR.danger,
    icon: 'fa fa-level-up',
  },
};

export const MAINTENANCE_WARNING_STATUS = {
  OPEN: { value: 'OPEN', label: 'Abierto', color: 'info' },
  IN_PROGRESS: { value: 'IN_PROGRESS', label: 'En progreso', color: 'warning' },
  REJECTED: { value: 'REJECTED', label: 'Rechazado', color: 'danger' },
  DONE: { value: 'DONE', label: 'Realizado', color: 'success' },
};

export const MAINTENANCE_WARNING_RECURRENCE = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
];

export const MAINTENANCE_SERVICE_ORDER_PRIORITY = {
  LOW: {
    value: 'LOW',
    label: 'Baja',
    color: 'secondary',
    hexColor: COLOR.darkGray,
    icon: 'fa fa-level-down',
  },
  MEDIUM: {
    value: 'MEDIUM',
    label: 'Media',
    color: 'warning',
    hexColor: COLOR.orange,
    icon: 'fa fa-arrows-h',
  },
  HIGH: {
    value: 'HIGH',
    label: 'Alta',
    color: 'danger',
    hexColor: COLOR.red,
    icon: 'fa fa-level-up',
  },
};

export const MAINTENANCE_SERVICE_ORDER_STATUS = {
  OPEN: {
    value: 'OPEN',
    label: 'Abierto',
    color: 'warning',
    hexColor: COLOR.orange,
  },
  IN_PROGRESS: {
    value: 'IN_PROGRESS',
    label: 'En progreso',
    color: 'info',
    hexColor: COLOR.skyBlue,
  },
  DONE: {
    value: 'DONE',
    label: 'Realizado',
    color: 'success',
    hexColor: COLOR.green,
  },
};

export const ACTIVITY_TASK_EXECUTION_STATUS = {
  OPEN: { value: 'OPEN', label: 'Abierto' },
  ASSIGNED: { value: 'ASSIGNED', label: 'Asignado' },
  IN_PROGRESS: { value: 'IN_PROGRESS', label: 'En proceso' },
  DONE: { value: 'DONE', label: 'Realizado' },
};

export const ACTIVITY_ACTION = {
  REVIEW: { value: 'REVIEW', label: 'Revisar' },
  REPAIR: { value: 'REPAIR', label: 'Reparar' },
  CHANGE: { value: 'CHANGE', label: 'Cambiar' },
  SCHEDULED_MEETING: {
    value: 'SCHEDULED_MEETING',
    label: 'Reunión Programada',
  },
  GENERAL_MAINTENANCE: {
    value: 'GENERAL_MAINTENANCE',
    label: 'Mantenimiento General',
  },
};

export const ACTIVITY_EXECUTION_METHOD = {
  CONDITION_BASED: { value: 'CONDITION_BASED', label: 'Basado en condición' },
  CYCLICAL_REPLACEMENT: {
    value: 'CYCLICAL_REPLACEMENT',
    label: 'Reemplazo cíclico',
  },
};

export const FLIT_ROBOT_CUSTOMER_ID = 9999999;

export const PARCEL_PAYMENT_STATUS = {
  WAITING_FOR_PAYMENT: {
    value: 'WAITING_FOR_PAYMENT',
    label: 'Esperando pago',
    color: 'danger',
  },
  PAID: { value: 'PAID', label: 'Pagado', color: 'success' },
};

export const PAYMENT_METHOD_PAGO_EN_DESTINO = 'PAYMENT_ON_ARRIVAL';
export const PAYMENT_METHOD_BUSINESS_CREDIT = 'BUSINESS_CREDIT';
export const MANUAL_GRR_MOTIVE_OPTIONS = [
  {
    value: '01',
    label: 'Venta',
  },
  {
    value: '04',
    label: 'Traslado entre establecimientos de la misma empresa',
  },
  {
    value: '13',
    label: 'Otros',
  },
];

export const MANUAL_GRR_VOUCHER_TYPES_OPTIONS = [
  {
    value: 'FACTURA',
    label: 'Factura',
  },
  {
    value: 'BOLETA_DE_VENTA',
    label: 'Boleta de venta',
  },
  {
    value: 'LIQUIDACION_DE_COMPRA',
    label: 'Liquidación de compra',
  },
  {
    value: 'BOLETOS_TRANSPORTE_AEREO',
    label: 'Boleto de Transporte Aereo',
  },
  {
    value: 'CARTA_PORTE_AEREO',
    label: 'Carta de porte aéreo',
  },
];
export const GRR_MOTIVE_SALE = '01';
export const GRR_MOTIVE_INTERNAL_TRANSFER = '04';
export const GRR_MOTIVE_BUSINESS_TRANSFER = '17';
export const GRR_MOTIVE_OTHERS = '13';

export const CARGO_ITEM_CHANGE_STATUS_BUTTON = {
  UNCLAIMED: { value: 'UNCLAIMED', label: 'Sin reclamar' },
  DEPURATED: { value: 'DEPURATED', label: 'Depurado' },
  SEIZED: { value: 'SEIZED', label: 'Incautado' },
  LOST: { value: 'LOST', label: 'No llego' },
  APPROPRIATE: { value: 'APPROPRIATE', label: 'Apropiar' },
};

export const CARGO_ITEM_CHANGE_STATUS_DROPDOWN_OPTIONS = [
  { value: 'header', label: 'Estados' },
  {
    value: CARGO_ITEM_CHANGE_STATUS_BUTTON.UNCLAIMED.value,
    label: 'Sin reclamar',
  },
  { value: CARGO_ITEM_CHANGE_STATUS_BUTTON.DEPURATED.value, label: 'Depurado' },
  { value: CARGO_ITEM_CHANGE_STATUS_BUTTON.SEIZED.value, label: 'Incautado' },
  { value: CARGO_ITEM_CHANGE_STATUS_BUTTON.LOST.value, label: 'No llego' },
];

export const CARGO_ITEM_STATUS = {
  RECEIVED: { value: 'RECEIVED', label: 'Registrado' },
  IN_TRANSIT: { value: 'IN_TRANSIT', label: 'Despachado' },
  READY_FOR_PICKUP: {
    value: 'READY_FOR_PICKUP',
    label: 'Recepcionado en destino',
    color: 'primary',
  },
  REFUNDED: { value: 'REFUNDED', label: 'Devuelto al cliente' },
  DELIVERED: { value: 'DELIVERED', label: 'Entregado', color: 'success' },
  UNCLAIMED: { value: 'UNCLAIMED', label: 'Sin reclamar' },
  DEPURATED: { value: 'DEPURATED', label: 'Depurado' },
  LOST: { value: 'LOST', label: 'No llego', color: 'danger' },
  SEIZED: { value: 'SEIZED', label: 'Incautado' },
  UNCLAIMED_IN_TRANSIT: {
    value: 'UNCLAIMED_IN_TRANSIT',
    label: 'Sin reclamar - en tránsito',
  },
  IN_TEMPORAL_AGENCY: {
    value: 'COMMERCIAL_SCALE',
    label: 'En escala comercial',
  },
  REGISTERED_FOR_DELIVERY: {
    value: 'REGISTERED_FOR_DELIVERY',
    label: 'Registrado para reparto',
    color: 'info',
  },
  DELIVERY_IN_TRANSIT: {
    value: 'DELIVERY_IN_TRANSIT',
    label: 'Reparto - en tránsito',
    color: 'warning',
  },
  BACK_TO_AGENCY: {
    value: 'BACK_TO_AGENCY',
    label: 'Regresando a agencia',
    color: 'info',
  },
  RETURNED: {
    value: 'RETURNED',
    label: 'Retornado a almacén',
    color: 'info',
  },
  APPROPRIATE: {
    value: 'APPROPRIATE',
    label: 'Apropiado',
  },
};

export const CARGO_ITEM_PERISHABLE_OPTIONS = [
  {
    value: true,
    label: 'Perecible',
  },
  {
    value: false,
    label: 'No perecible',
  },
];

export const INTERNAL_CARGO_ITEM_CHANGE_STATUS_BUTTON = {
  SEIZED: { value: 'SEIZED', label: 'Incautado' },
  LOST: { value: 'LOST', label: 'No llego' },
};

export const INTERNAL_CARGO_ITEM_CHANGE_STATUS_DROPDOWN_OPTIONS = [
  { value: 'header', label: 'Estados' },
  { value: CARGO_ITEM_CHANGE_STATUS_BUTTON.SEIZED.value, label: 'Incautado' },
  { value: CARGO_ITEM_CHANGE_STATUS_BUTTON.LOST.value, label: 'No llego' },
];

export const SEAT_STATUS = {
  FREE: 'FREE',
  OCCUPIED: 'OCCUPIED',
  IN_PROGRESS: 'IN_PROGRESS',
  CALL_CENTER_RESERVATION: 'CALL_CENTER_RESERVATION',
  DRIVER_RESERVED: 'DRIVER_RESERVED',
};

export const BILL_PROCESS_STATUS_PROCESSED = 'PROCESSED';

export const PARCEL_PAYMENT_STATUS_WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT';

export const TICKET_BOARDED_STATUS = {
  UNREGISTERED: {
    value: 'UNREGISTERED',
    label: 'Sin Registrar',
    color: 'info',
  },
  UNBOARDED: { value: 'UNBOARDED', label: 'No embarcó', color: 'warning' },
  BOARDED: { value: 'BOARDED', label: 'Embarcado', color: 'success' },
};

export const CARGO_OPERATIONS = {
  ADD_ITEM: {
    value: 'ADD_ITEM',
    label: 'Subir encomienda',
    color: 'success',
    labelDinamic: (quantity) =>
      `Subir ${quantity} ${quantity > 1 ? 'encomiendas' : 'encomienda'}`,
    searchType: 'UPLOAD',
  },
  UNLOAD_ITEM: {
    value: 'UNLOAD_ITEM',
    label: 'Bajar encomienda',
    color: 'warning',
    labelDinamic: (quantity) =>
      `Bajar ${quantity} ${quantity > 1 ? 'encomiendas' : 'encomienda'}`,
    searchType: 'DOWNLOAD',
  },
  MANIFEST: {
    value: 'MANIFEST',
    label: 'Manifiesto',
    color: 'info',
    labelDinamic: (quantity) =>
      `Manifiesto ${quantity} ${quantity > 1 ? 'encomiendas' : 'encomienda'}`,
    searchType: null,
  },
};

export const PAYMENT_STATUS = {
  PENDING: { value: 'PENDING', label: 'Pendiente', color: 'warning' },
  REJECTED: { value: 'REJECTED', label: 'Rechazado', color: 'danger' },
  APPROVED: { value: 'APPROVED', label: 'Aprobado', color: 'success' },
};

export const COMPANY_STAFF_TYPE = {
  HOLDERS: { value: 'HOLDERS', label: 'Titulares', color: 'success' },
  CONTRACTORS: {
    value: 'CONTRACTORS',
    label: 'Contratistas',
    color: 'warning',
  },
  BOTH: { value: 'BOTH', label: 'Ambos', color: 'info' },
};

export const TRIP_REQUEST_STATUS = {
  PENDING: {
    value: 'PENDING',
    label: 'Pendiente',
    color: 'warning',
  },
  APPROVED: {
    value: 'APPROVED',
    label: 'Aprobado',
    color: 'success',
  },
  REJECTED: {
    value: 'REJECTED',
    label: 'Rechazado',
    color: 'danger',
  },
};

export const COMPANY_BUS_SEAT_COUNT = 43;
export const MIN_COMPANY_BUS_SEAT_COUNT = 28;

export const PARCEL_PRICE_STATUS = {
  INACTIVE: { value: 'INACTIVE', label: 'Inactivo', color: 'danger' },
  ACTIVE: { value: 'ACTIVE', label: 'Activo', color: 'success' },
  PROCESSING: { value: 'PROCESSING', label: 'Procesando', color: 'info' },
};

export const PARCEL_CATEGORY_ENVELOPE = 'Sobre';

export const PARCEL_TEMPLATE_FILENAME = 'Tarifario';

export const DELIVERY_POSTAL_CODE_TEMPLATE_FILENAME =
  'Tarifario por Código Postal';

export const DRIVER_STATUS_OPTION = [
  {
    value: 1,
    label: 'OPERATIVO',
  },
  {
    value: 2,
    label: 'VACACIONES',
  },
  {
    value: 3,
    label: 'SUSPENDIDO',
  },
  {
    value: 4,
    label: 'DESACTIVADO',
  },
];

export const PARCEL_PRICE_CONFIGURATION = {
  BASE_PRICE: {
    value: 'BASE_PRICE',
    label: 'Precio Base',
  },
  VOLUMETRIC_DIVISOR: {
    value: 'VOLUMETRIC_DIVISOR',
    label: 'Divisor Volumétrico',
  },
  MAX_ENVELOPE_WEIGHT: {
    value: 'MAX_ENVELOPE_WEIGHT',
    label: 'Peso Máximo Sobre',
  },
};

export const MAINTENANCE_PLANNING_STATUS = {
  CREATED: {
    value: 'CREATED',
    label: 'Creado',
    color: 'warning',
    hexColor: COLOR.orange,
  },
  STARTED: {
    value: 'STARTED',
    label: 'En Progreso',
    color: 'info',
    hexColor: COLOR.warning,
  },
  DECLINED: {
    value: 'DECLINED',
    label: 'Rechazado',
    color: 'danger',
    hexColor: COLOR.danger,
  },
  DONE: {
    value: 'DONE',
    label: 'Terminado',
    color: 'warning',
    hexColor: COLOR.danger,
  },
};

export const MAINTENANCE_FACTOR_TYPE_LABEL = {
  KILOMETER: {
    value: 'KILOMETER',
    label: 'Kilometros',
    color: 'info',
    hexColor: COLOR.skyBlue,
  },
  DAY: {
    value: 'DAY',
    label: 'Dias',
    color: 'info',
    hexColor: COLOR.skyBlue,
  },
};

export const MAINTENANCE_PLANNING_TYPE_LABEL = {
  LINEAL: {
    value: 'LINEAL',
    label: 'Lineal',
    color: 'info',
    hexColor: COLOR.skyBlue,
  },
  CICLICAL: {
    value: 'CICLICAL',
    label: 'Ciclico',
    color: 'info',
    hexColor: COLOR.skyBlue,
  },
};

export const MAINTENANCE_WARNING_STATUS_ACTIVITY = {
  OVERDUE: {
    value: 'OVERDUE',
    label: 'Vencido',
    color: 'danger',
  },
  DUE_SOON: { value: 'DUE_SOON', label: 'Por Vencer', color: 'warning' },
  IN_RANGE: { value: 'IN_RANGE', label: 'En Rango', color: 'info' },
  EXTENDED: { value: 'EXTENDED', label: 'Extendido', color: 'primary' },
};

export const MAINTENANCE_PLANNING_STATUS_CREATED = 'CREATED';

export const MAINTENANCE_PLANNING_STATUS_STARTED = 'STARTED';

export const MAINTENANCE_PLANNING_STATUS_DONE = 'DONE';

export const MAX_LENGTH_TEXTAREA_FOR_INTERNAL_PARCEL = 1000;

export const CONTINGENCY_MOTIVE_OPTION = [
  { value: 'Conexión Internet', label: 'Conexión Internet' },
  { value: 'Fallas de fluido eléctrico', label: 'Fallas de fluido eléctrico' },
];

export const LEGAL_ABANDONMENT_STATUS_OPTIONS = {
  OK: {
    value: 'OK',
    label: 'OK',
  },
  OPEN: {
    value: 'OPEN',
    label: 'ABIERTO',
  },
  FORCE: {
    value: 'FORCE',
    label: 'VIOLENTADO',
  },
  LOST: {
    value: 'LOST',
    label: 'PERDIDO',
  },
};

export const REQUIRED_CARGO_ITEM_DOWNLOAD_FILTERS = [
  { param: 'locationId', description: 'Ubicación' },
  { param: 'status', description: 'Estado' },
];

export const FILTER_DEPENDENCIES_CARGO_ITEM_DOWNLOAD = {
  'parcel.paymentStatus': ['status'],
  status: [
    {
      values: ['APPROPRIATE', 'SEIZED'],
      // eslint-disable-next-line no-useless-escape
      separator: /[\/|]/,
      removeRequired: ['locationId'],
      addRequired: [
        { param: 'finalDestinationLocationId', description: 'Destino' },
      ],
    },
  ],
};

export const PARCEL_STATUS_UNCLAIMED = 'UNCLAIMED';

export const ROBOT_FLIT_COMPANY_AREA = 9999999;

export const CREDIT_NOTE_MANUAL_VOUCHER_REASONS = {
  OPERATION_CANCELLATION: {
    value: 'OPERATION_CANCELLATION',
    code: '01',
    label: 'Anulación de la operación',
  },
  RUC_ERROR_CANCELLATION: {
    value: 'RUC_ERROR_CANCELLATION',
    code: '02',
    label: 'Anulación por error en el RUC',
  },
  DESCRIPTION_ERROR_CORRECTION: {
    value: 'DESCRIPTION_ERROR_CORRECTION',
    code: '03',
    label: 'Corrección por error en la descripción',
  },
  GLOBAL_DISCOUNT: {
    value: 'GLOBAL_DISCOUNT',
    code: '04',
    label: 'Descuento global',
  },
  ITEM_DISCOUNT: {
    value: 'ITEM_DISCOUNT',
    code: '05',
    label: 'Descuento por ítem',
  },
  TOTAL_RETURN: {
    value: 'TOTAL_RETURN',
    code: '06',
    label: 'Devolución total',
  },
  ITEM_RETURN: {
    value: 'ITEM_RETURN',
    code: '07',
    label: 'Devolución por ítem',
  },
  BONUS: {
    value: 'BONUS',
    code: '08',
    label: 'Bonificación',
  },
  VALUE_DECREASE: {
    value: 'VALUE_DECREASE',
    code: '09',
    label: 'Disminución en el valor',
  },
  OTHER_CONCEPTS: {
    value: 'OTHER_CONCEPTS',
    code: '10',
    label: 'Otros conceptos',
  },
  EXPORT_OPERATION_ADJUSTMENTS: {
    value: 'EXPORT_OPERATION_ADJUSTMENTS',
    code: '11',
    label: 'Ajustes de operaciones de exportación',
  },
  IVAP_ADJUSTMENTS: {
    value: 'IVAP_ADJUSTMENTS',
    code: '12',
    label: 'Ajustes afectos al IVAP',
  },
  PAYMENT_CORRECTION: {
    value: 'PAYMENT_CORRECTION',
    code: '13',
    label:
      'Corrección del monto neto pendiente de pago y/o la(s) fecha(s) de vencimiento del pago único o de las cuotas y/o los montos correspondientes a cada cuota, de ser el caso',
  },
};

export const GENERAL_STATUS = {
  PENDING: {
    value: 'PENDING',
    label: 'Pendiente',
    color: 'warning',
  },
  APPROVED: {
    value: 'APPROVED',
    label: 'Aprobado',
    color: 'success',
  },
  REJECTED: {
    value: 'REJECTED',
    label: 'Rechazado',
    color: 'danger',
  },
};

export const MAX_LENGTH_TEXTAREA_FOR_COMPANY_RESOURCE = 450;

export const MAX_LENGTH_TEXTAREA_FOR_DRIVER_MOVEMENT_HISTORY_NOTE = 255;

export const MONTH_OPTIONS = [
  {
    value: 1,
    label: 'Enero',
  },
  {
    value: 2,
    label: 'Febrero',
  },
  {
    value: 3,
    label: 'Marzo',
  },
  {
    value: 4,
    label: 'Abril',
  },
  {
    value: 5,
    label: 'Mayo',
  },
  {
    value: 6,
    label: 'Junio',
  },
  {
    value: 7,
    label: 'Julio',
  },
  {
    value: 8,
    label: 'Agosto',
  },
  {
    value: 9,
    label: 'Septiembre',
  },
  {
    value: 10,
    label: 'Octubre',
  },
  {
    value: 11,
    label: 'Noviembre',
  },
  {
    value: 12,
    label: 'Diciembre',
  },
];

export const DRIVER_STATUS_TYPE = {
  ACTIVE: { value: 'ACTIVE', label: 'Activo', color: 'success' },
  INACTIVE: { value: 'INACTIVE', label: 'Desactivado', color: 'danger' },
  UNAVAILABLE: {
    value: 'UNAVAILABLE',
    label: 'No disponible',
    color: 'warning',
  },
};

export const REJECTED_EXPENSE_OPTIONS = {
  INCORRECT_AMOUNT: {
    value: 'INCORRECT_AMOUNT',
    label: 'Monto Incorrecto',
    color: 'danger',
  },
  INCORRECT_AUTHORIZER_USER: {
    value: 'INCORRECT_AUTHORIZER_USER',
    label: 'Usuario Autorizador Incorrecto',
    color: 'info',
  },
  INCORRECT_COST_CENTER: {
    value: 'INCORRECT_COST_CENTER',
    label: 'Centro de Costo Incorrecto',
    color: 'warning',
  },
};

export const ACTIVE_OPTIONS = [
  {
    value: true,
    label: 'Activo',
  },
  {
    value: false,
    label: 'Inactivo',
  },
];

export const DELIVERY_STATUS = {
  REGISTERED: { value: 'REGISTERED', label: 'Registrado', color: 'primary' },
  IN_TRANSIT: { value: 'IN_TRANSIT', label: 'En tránsito', color: 'warning' },
  COMPLETED: { value: 'COMPLETED', label: 'Completado', color: 'success' },
};

export const BACK_TO_AGENCY_REASONS = {
  CLIENT_NOT_FOUND: {
    value: 'CLIENT_NOT_FOUND',
    label: 'No se encontró al cliente en el lugar de entrega',
  },
};

export const CORPORATE_CREDIT_OPTIONS = {
  COMPANY: { value: 'COMPANY', label: 'Empresa' },
  PERSON: { value: 'CUSTOMER', label: 'Persona Natural' },
};

export const CARGO_CUSTOMER_TYPE = {
  SENDER: {
    value: 0,
    label: 'Remitente',
  },
  CONSIGNEE: {
    value: 1,
    label: 'Consignado',
  },
  SENDER_CONSIGNEE: {
    value: 2,
    label: 'Remitente y Consignado',
  },
};

export const CARGO_GLOBAL_PARCEL_PRICE_CONFIGURATION_ID = 1;

export const CARGO_CORPORATE_CREDIT_BUTTON = {
  CITY: { value: 'city', label: 'Ciudades Asociadas' },
  ADD_CUSTOMER: {
    value: 'customer',
    label: 'Asociar Personal Corporativo',
  },
  IMPORT_CUSTOMER: {
    value: 'import-customer',
    label: 'Importar Personal Corporativo',
  },
  COMMON_PRODUCT: {
    value: 'common-product',
    label: 'Agregar Producto Frecuente',
  },
  PARCEL_PRICE_CONFIGURATION: {
    value: 'parcel-price-configuration',
    label: 'Configuración de Tarifa',
  },
  ADD_PARCEL_PRICE: {
    value: 'add-parcel-price',
    label: 'Nueva Tarifa',
  },
};

export const CARGO_CORPORATE_CREDIT_DROPDOWN_OPTIONS = [
  {
    value: CARGO_CORPORATE_CREDIT_BUTTON.IMPORT_CUSTOMER.value,
    label: CARGO_CORPORATE_CREDIT_BUTTON.IMPORT_CUSTOMER.label,
  },
  {
    value: CARGO_CORPORATE_CREDIT_BUTTON.CITY.value,
    label: CARGO_CORPORATE_CREDIT_BUTTON.CITY.label,
  },
  {
    value: CARGO_CORPORATE_CREDIT_BUTTON.ADD_CUSTOMER.value,
    label: CARGO_CORPORATE_CREDIT_BUTTON.ADD_CUSTOMER.label,
  },
  {
    value: CARGO_CORPORATE_CREDIT_BUTTON.COMMON_PRODUCT.value,
    label: CARGO_CORPORATE_CREDIT_BUTTON.COMMON_PRODUCT.label,
  },
  {
    value: CARGO_CORPORATE_CREDIT_BUTTON.PARCEL_PRICE_CONFIGURATION.value,
    label: CARGO_CORPORATE_CREDIT_BUTTON.PARCEL_PRICE_CONFIGURATION.label,
  },
  {
    value: CARGO_CORPORATE_CREDIT_BUTTON.ADD_PARCEL_PRICE.value,
    label: CARGO_CORPORATE_CREDIT_BUTTON.ADD_PARCEL_PRICE.label,
  },
];

export const MAX_SHELF_SPACE_SIZE = 10;
export const DELIVERY_TEMPLATE_FILENAME = 'Tarifario de Reparto';
export const DELIVERY_PRICE_STATUS = {
  INACTIVE: { value: 'INACTIVE', label: 'Inactivo', color: 'danger' },
  ACTIVE: { value: 'ACTIVE', label: 'Activo', color: 'success' },
  PROCESSING: { value: 'PROCESSING', label: 'Procesando', color: 'info' },
};

export const COMMON_PRODUCT_PRICE_SCHEDULE_STATUS = {
  INACTIVE: { value: 'INACTIVE', label: 'Inactivo', color: 'danger' },
  ACTIVE: { value: 'ACTIVE', label: 'Activo', color: 'success' },
  PROCESSING: { value: 'PROCESSING', label: 'Procesando', color: 'info' },
};

export const DOCUMENT_TYPE_CHINALCO = {
  DNI: { value: 1, label: 'DNI' },
  CE: { value: 2, label: 'C.E.' },
  PASAPORTE: { value: 61, label: 'PASAPORTE' },
};

export const SUITABLE_STATUS = {
  UNREGISTERED: {
    value: 'UNREGISTERED',
    label: 'Sin Registrar',
    color: 'info',
  },
  SUITABLE: { value: 'SUITABLE', label: 'Apto', color: 'success' },
  UNSUITABLE: { value: 'UNSUITABLE', label: 'No Apto', color: 'warning' },
};

export const VOID_REASONS = {
  SCHEDULE_CHANGE: {
    value: 'SCHEDULE_CHANGE',
    label: 'Cambio de Programación',
  },
  COMPANY_REQUEST: {
    value: 'COMPANY_REQUEST',
    label: 'Por solicitud de empresa',
  },
};

export const ITINERARY_PRINT_DROPDOWN_OPTIONS_COMPANY = [
  { value: 'header', label: 'Pasajeros' },
  { value: ITINERARY_PRINT_BUTTON.MANIFEST.value, label: 'Manifiesto' },
];

export const BUS_MAINTENANCE_STATUS_TYPE = {
  OPERATIONAL: { value: 'OPERATIONAL', label: 'Operativo' },
  EXTENDED_MAINTENANCE: {
    value: 'EXTENDED_MAINTENANCE',
    label: 'Mantenimiento Extendido',
  },
  NOT_SCHEDULED: { value: 'NOT_SCHEDULED', label: 'No Programar' },
  LOGISTICS: { value: 'LOGISTICS', label: 'Logística' },
};

export const ITINERARY_SERVICE_TYPE = {
  EXCLUCIVA: { value: 5, label: 'Excluciva' },
};

export const ROUTE_LENGTH_TYPE_OPTIONS = {
  UNKNOWN: { value: 'UNKNOWN', label: 'Desconocido' },
  SHORT: { value: 'SHORT', label: 'Corta' },
  MEDIUM: { value: 'MEDIUM', label: 'Intermedia' },
  LONG: { value: 'LONG', label: 'Larga' },
};

export const TICKET_MASSIVE_POSTPONE_TYPE_OPTIONS = {
  IMMEDIATE: { value: 'IMMEDIATE', label: 'Inmediato' },
  NON_IMMEDIATE: { value: 'NON_IMMEDIATE', label: 'No Inmediato' },
};

export const MAINTENANCE_RESET_RULE_TYPE = {
  DAY_OF_MONTH: { value: 'DAY_OF_MONTH', label: 'Día específico del mes' },
  DAY_OF_WEEK: { value: 'DAY_OF_WEEK', label: 'Día específico de la semana' },
  MONTH_RANGE: { value: 'MONTH_RANGE', label: 'Rango de días del mes' },
  NTH_WEEKDAY: { value: 'NTH_WEEKDAY', label: 'N-ésimo día-semana del mes' },
};

export const MAINTENANCE_WEEK_DAYS = {
  0: { value: 0, label: 'Lunes' },
  1: { value: 1, label: 'Martes' },
  2: { value: 2, label: 'Miércoles' },
  3: { value: 3, label: 'Jueves' },
  4: { value: 4, label: 'Viernes' },
  5: { value: 5, label: 'Sábado' },
  6: { value: 6, label: 'Domingo' },
};

export const MAINTENANCE_MONTH_WEEK_NUMBERS = {
  1: { value: 0, label: 'Primera semana' },
  2: { value: 1, label: 'Segunda semana' },
  3: { value: 2, label: 'Tercera semana' },
  4: { value: 3, label: 'Cuarta semana' },
};

export const MAINTENANCE_RESET_RULE_TYPE_STATUS = {
  DAY_OF_MONTH: {
    value: 'DAY_OF_MONTH',
    label: 'Día específico del mes',
    color: 'info',
    hexColor: COLOR.info,
  },
  DAY_OF_WEEK: {
    value: 'DAY_OF_WEEK',
    label: 'Día específico de la semana',
    color: 'info',
    hexColor: COLOR.info,
  },
  MONTH_RANGE: {
    value: 'MONTH_RANGE',
    label: 'Rango de días del mes',
    color: 'info',
    hexColor: COLOR.info,
  },
  NTH_WEEKDAY: {
    value: 'NTH_WEEKDAY',
    label: 'N-ésimo día-semana del mes',
    color: 'info',
    hexColor: COLOR.info,
  },
};

export const MAINTENANCE_RESET_RULE_DAY_OF_WEEK = {
  0: {
    value: '0',
    label: 'Lunes',
    color: 'primary',
    hexColor: COLOR.primary,
  },
  1: {
    value: '1',
    label: 'Martes',
    color: 'primary',
    hexColor: COLOR.primary,
  },
  2: {
    value: '2',
    label: 'Miércoles',
    color: 'primary',
    hexColor: COLOR.primary,
  },
  3: {
    value: '3',
    label: 'Jueves',
    color: 'primary',
    hexColor: COLOR.primary,
  },
  4: {
    value: '4',
    label: 'Viernes',
    color: 'primary',
    hexColor: COLOR.primary,
  },
  5: {
    value: '5',
    label: 'Sábado',
    color: 'primary',
    hexColor: COLOR.primary,
  },
  6: {
    value: '6',
    label: 'Domingo',
    color: 'primary',
    hexColor: COLOR.primary,
  },
};

export const MAINTENANCE_RESET_RULE_NTH_WEEKDAY = {
  0: {
    value: '0',
    label: 'Primera semana',
    color: 'primary',
    hexColor: COLOR.orange,
  },
  1: {
    value: '1',
    label: 'Segunda semana',
    color: 'primary',
    hexColor: COLOR.orange,
  },
  2: {
    value: '2',
    label: 'Tercera semana',
    color: 'primary',
    hexColor: COLOR.orange,
  },
  3: {
    value: '3',
    label: 'Cuarta semana',
    color: 'primary',
    hexColor: COLOR.orange,
  },
};

export const CUSTOMER_URL = 'http://trabajoen.civa.com.pe/';

export const GOOGLE_CLOUD_TOKEN =
  process.env.REACT_APP_GOOGLE_CLOUD_TOKEN || '';

export const YANDEX_BUSINESS_NUMBER = '20606384140';

export const YANGO_DELIVERY_STATUS = {
  new: { value: 'new', label: 'Nuevo', color: 'default' },
  estimating: { value: 'estimating', label: 'Estimando', color: 'info' },
  estimating_failed: {
    value: 'estimating_failed',
    label: 'Error en estimación',
    color: 'danger',
  },
  ready_for_approval: {
    value: 'ready_for_approval',
    label: 'Listo para aprobar',
    color: 'primary',
  },
  accepted: { value: 'accepted', label: 'Aceptado', color: 'primary' },
  performer_lookup: {
    value: 'performer_lookup',
    label: 'Buscando repartidor',
    color: 'info',
  },
  performer_draft: {
    value: 'performer_draft',
    label: 'Repartidor en borrador',
    color: 'info',
  },
  performer_found: {
    value: 'performer_found',
    label: 'Repartidor encontrado',
    color: 'success',
  },
  performer_not_found: {
    value: 'performer_not_found',
    label: 'Repartidor no encontrado',
    color: 'warning',
  },
  pickup_arrived: {
    value: 'pickup_arrived',
    label: 'Llegada al punto de recojo',
    color: 'info',
  },
  ready_for_pickup_confirmation: {
    value: 'ready_for_pickup_confirmation',
    label: 'Listo para confirmar recojo',
    color: 'primary',
  },
  pickuped: { value: 'pickuped', label: 'Recolectado', color: 'success' },
  delivery_arrived: {
    value: 'delivery_arrived',
    label: 'Llegada al destino',
    color: 'info',
  },
  ready_for_delivery_confirmation: {
    value: 'ready_for_delivery_confirmation',
    label: 'Listo para confirmar entrega',
    color: 'primary',
  },
  delivered: { value: 'delivered', label: 'Entregado', color: 'success' },
  delivered_finish: {
    value: 'delivered_finish',
    label: 'Entrega finalizada',
    color: 'success',
  },
  returning: { value: 'returning', label: 'En retorno', color: 'warning' },
  return_arrived: {
    value: 'return_arrived',
    label: 'Llegada del retorno',
    color: 'info',
  },
  ready_for_return_confirmation: {
    value: 'ready_for_return_confirmation',
    label: 'Listo para confirmar retorno',
    color: 'primary',
  },
  returned: { value: 'returned', label: 'Retornado', color: 'success' },
  returned_finish: {
    value: 'returned_finish',
    label: 'Retorno finalizado',
    color: 'success',
  },
  failed: { value: 'failed', label: 'Fallido', color: 'danger' },
  cancelled: { value: 'cancelled', label: 'Cancelado', color: 'danger' },
  cancelled_with_payment: {
    value: 'cancelled_with_payment',
    label: 'Cancelado con pago',
    color: 'warning',
  },
  cancelled_by_taxi: {
    value: 'cancelled_by_taxi',
    label: 'Cancelado por taxi',
    color: 'warning',
  },
  cancelled_with_items_on_hands: {
    value: 'cancelled_with_items_on_hands',
    label: 'Cancelado con items en mano',
    color: 'warning',
  },
};

export const GEOFENCE_ALERT_TYPE = {
  GEOFENCE_ENTRY: { value: 0, label: 'Entrada' },
  GEOFENCE_EXIT: { value: 1, label: 'Salida' },
};

export const TICKET_BOARDED_STATUS_CODE = {
  UNREGISTERED: {
    value: 'UNREGISTERED',
    label: 'SR',
    color: 'info',
  },
  UNBOARDED: { value: 'UNBOARDED', label: 'NE', color: 'warning' },
  BOARDED: { value: 'BOARDED', label: 'E', color: 'success' },
};

export const LEGAL_SOURCE_SYSTEM = {
  FLIT: { value: 'FLIT', label: 'FLIT' },
  BETTEREZ: { value: 'BETTEREZ', label: 'BETTEREZ' },
  OLD: { value: 'OLD', label: 'OLD' },
};

export const TICKET_BOARDED_STATUS_CODE_LABEL = {
  UNREGISTERED: {
    value: 'UNREGISTERED',
    label: 'Sin Registrar',
    color: 'info',
  },
  UNBOARDED: { value: 'UNBOARDED', label: 'No Embarco', color: 'warning' },
  BOARDED: { value: 'BOARDED', label: 'Embarco', color: 'success' },
};

export const DISCOUNT_CODE_TYPE = {
  PERCENTAGE: { value: 'PERCENTAGE', label: 'Porcentaje' },
  FINAL_PRICE: { value: 'FINAL_PRICE', label: 'Precio Final' },
};

export const DISCOUNT_CODE_FLOOR_RULE = {
  FIRST_FLOOR: { value: 'FIRST_FLOOR', label: 'Primer Piso' },
  SECOND_FLOOR: { value: 'SECOND_FLOOR', label: 'Segundo Piso' },
  BOTH_FLOOR: { value: 'BOTH_FLOOR', label: 'Ambos Pisos' },
};

export const CARGO_PLUS_PRICE_OPTIONS = [
  {
    value: 5,
    label: 'S/ 5.00',
  },
  {
    value: 10,
    label: 'S/ 10.00',
  },
  {
    value: 15,
    label: 'S/ 15.00',
  },
  {
    value: 20,
    label: 'S/ 20.00',
  },
];

export const DISCOUNT_PRODUCT_TYPE = {
  BAGGAGE: { value: 'BAGGAGE', label: 'Equipaje' },
  // TODO: implement other types of products
};

export const ITINERARY_EXPENSE_ALERT_TYPE = {
  PRINT: { value: 'PRINT', label: 'Imprimir' },
  REPRINT: { value: 'REPRINT', label: 'Reimprimir' },
  ALERT_EXISTING_EXPENSE: {
    value: 'ALERT_EXISTING_EXPENSE',
    label: 'Alerta de gasto existente',
  },
};

export const ITINERARY_SUGGESTION_DETAIL = {
  AVAILABILITY: {
    value: 'AVAILABILITY',
    label: 'Disponibilidad',
    message: 'El bus está disponible para la fecha y hora del itinerario',
  },
  GROUP: {
    value: 'GROUP',
    label: 'Grupo',
    message: 'El Bus Forma parte de la agrupación de Asignación de Rutas',
  },
  MAINTENANCE: {
    value: 'MAINTENANCE',
    label: 'Mantenimiento',
    message:
      'El bus no tiene mantenimientos programados en la fecha del itinerario',
  },
  CHARACTERISTICS: {
    value: 'CHARACTERISTICS',
    label: 'Características',
    message:
      'El bus cumple con las características requeridas por el itinerario',
  },
  ALTERNATION: {
    value: 'ALTERNATION',
    label: 'Alternancia',
    message: 'Alternancia de longitud de carretera',
  },
  NOT_RETURN: {
    value: 'NOT_RETURN',
    label: 'Sin Devolución',
    color: 'warning',
  },
};

export const STATUS_TRANSLATIONS = {
  READY_FOR_PROCESS: 'Listo para procesar',
  PROCESSED: 'Procesado',
  ERROR: 'Error',
  IN_PROGRESS: 'En progreso',
  READY_FOR_TICKET: 'Listo para Ticket',
  TICKET_IN_PROGRESS: 'Ticket en progreso',
  CDR_IN_PROGRESS: 'CDR en progreso',
};

export const SENDER_REMISSION_GUIDE_ITEM_STATUS = {
  SENT: { value: 'SENT', label: 'Enviado', color: 'info' },
  RETURNED: {
    value: 'RETURNED',
    label: 'Recepcionado en Origen',
    color: 'success',
  },
  AVAILABILITY: {
    value: 'AVAILABILITY',
    label: 'Disponibilidad',
    message: 'El bus está disponible para la fecha y hora del itinerario',
  },
  GROUP: {
    value: 'GROUP',
    label: 'Grupo',
    message: 'Forma parte de la agrupación de Buses del Circuito',
  },
  MAINTENANCE: {
    value: 'MAINTENANCE',
    label: 'Mantenimiento',
    message:
      'El bus no tiene mantenimientos programados en la fecha del itinerario',
  },
  CHARACTERISTICS: {
    value: 'CHARACTERISTICS',
    label: 'Características',
    message:
      'El bus cumple con las características requeridas por el itinerario',
  },
  ALTERNATION: {
    value: 'ALTERNATION',
    label: 'Alternancia',
    message: 'Alternancia de longitud de carretera',
  },
};

export const DOCUMENT_TYPE = {
  DNI: { value: 1, label: 'DNI' },
};

export const CURRENCY_TYPE = {
  PEN: { value: 'PEN', label: 'Soles', color: 'info' },
  USD: { value: 'USD', label: 'Dolares', color: 'info' },
  EUR: { value: 'EUR', label: 'Euros', color: 'info' },
};

export const ROAD_BOOKING_CITY = {
  LIMA: { value: 4, label: 'Lima' },
  BARRANCA: { value: 57, label: 'Barranca' },
};

export const ROAD_BOOKING_PAYMENT_TYPE = {
  CASH: { value: 1, label: 'Contado' },
  QR: { value: 20, label: 'Pago QR' }, // Billetera Digital
};

export const CONTRACT_TYPE_FOR_LATE_SEARCH = [
  CONTRACT_TYPE.DEFAULT.value,
  CONTRACT_TYPE.CONTACT_CENTER.value,
  CONTRACT_TYPE.ADMINISTRATIVE.value,
];

export const GEOGRAPHIC_ZONES = {
  CENTRAL: { value: 1, label: 'Centro' },
};

export const SENDER_REMISSION_GUIDE_EXIT_REASON = {
  WARRANTY: { value: 'WARRANTY', label: 'Garantía', color: 'warning' },
  REPAIR: { value: 'REPAIR', label: 'Reparación', color: 'danger' },
  SAMPLE: { value: 'SAMPLE', label: 'Muestra', color: 'success' },
  DONATION: { value: 'DONATION', label: 'Donación', color: 'primary' },
  RETURN: { value: 'RETURN', label: 'Devolución', color: 'info' },
  SALES: { value: 'SALES', label: 'Ventas', color: 'info' },
  NOT_RETURN: {
    value: 'NOT_RETURN',
    label: 'Sin Devolución',
    color: 'warning',
  },
  SCRAP: { value: 'SCRAP', label: 'Chatarra', color: 'danger' },
};

export const SENDER_REMISSION_GUIDE_ITEM_PICKUP_STATUS = {
  SENT: {
    value: 'SENT',
    label: 'Enviado',
    color: 'primary',
  },
  RETURNED: {
    value: 'RETURNED',
    label: 'Devuelto',
    color: 'info',
  },
  NEW: {
    value: 'NEW',
    label: 'Nuevo',
    color: 'success',
  },
  WARRANTY: {
    value: 'WARRANTY',
    label: 'Garantía',
    color: 'warning',
  },
  SCRAP: {
    value: 'SCRAP',
    label: 'Desecho',
    color: 'danger',
  },
  REPAIR: { value: 'REPAIR', label: 'Reparado', color: 'warning' },
  NOT_RETURN: {
    value: 'NOT_RETURN',
    label: 'Sin Devolución',
    color: 'warning',
  },
};

export const SENDER_REMISSION_GUIDE_CLOSURE_STATUS = {
  OPEN: {
    value: 'OPEN',
    label: 'Abierto',
    color: 'warning',
  },
  CLOSE: {
    value: 'CLOSE',
    label: 'Cerrado',
    color: 'success',
  },
};

export const DRIVER_ACTIVITY_EVENT_TYPE = {
  ITINERARY_DEPARTURE: {
    value: 'ITINERARY_DEPARTURE',
    label: 'Viaje',
    link: ITINERARY_FOR_COUNTER_PATH,
  },
  RETEN: { value: 'RETEN', label: 'Retén', link: null },
  MOVEMENT: {
    value: 'MOVEMENT',
    label: 'Movimiento',
    link: DRIVER_MOVEMENT_HISTORY_PATH,
  },
  CHANGE_TRIP_DRIVER: {
    value: 'CHANGE_TRIP_DRIVER',
    label: 'Cambio de Conductor de Viaje',
    link: ITINERARY_FOR_COUNTER_PATH,
  },
};

export const ITINERARY_DIRECTION = {
  LIMA_TO_PROVINCE: { value: 'LIMA_TO_PROVINCE', label: 'Lima a Provincia' },
  PROVINCE_TO_LIMA: { value: 'PROVINCE_TO_LIMA', label: 'Provincia a Lima' },
  PROVINCE_TO_PROVINCE: {
    value: 'PROVINCE_TO_PROVINCE',
    label: 'Provincia a Provincia',
  },
  LIMA_TO_LIMA: {
    value: 'LIMA_TO_LIMA',
    label: 'Lima a Lima',
  },
};

export const ITINERARY_SEARCH_DIRECTION_OPTIONS = [
  {
    value: 'LIMA_TO_PROVINCE',
    label: 'Lima a Provincia',
  },
  {
    value: 'PROVINCE_TO_LIMA',
    label: 'Provincia a Lima',
  },
  {
    value: 'PROVINCE_TO_PROVINCE',
    label: 'Provincia a Provincia',
  },
  {
    value: 'LIMA_TO_LIMA',
    label: 'Lima a Lima',
  },
];

export const ITINERARY_SCHEDULING_COLUMNS_STORAGE_KEYS = {
  USED: 'itinerariesForScheduling_columnsUsed',
  VISIBLE: 'itinerariesForScheduling_visibleColumns',
};

export const ITINERARY_SCHEDULING_COLUMN_OPTIONS = [
  { value: 'actions-bus', label: 'Acción - Programar Bus' },
  { value: 'actions-cabin-crew', label: 'Acción - Servicio a Bordo' },
  { value: 'departuretime', label: 'Fecha' },
  { value: 'sourceLocationName', label: 'Origen' },
  { value: 'destinationLocationName', label: 'Destino' },
  { value: 'departuretime-hour', label: 'Hora' },
  { value: 'waitTimeViolation', label: 'Tiempo de Permanencia Fallido (min)' },
  { value: 'serviceType', label: 'Tipo Servicio' },
  { value: 'passengerSeatCapacity', label: 'Capacidad de Asiento' },
  { value: 'companyBusId', label: 'Bus' },
  { value: 'busChangeCount', label: 'Cant. Cambios' },
  { value: 'changedBuses', label: 'Buses Cambiados' },
  { value: 'firstDriverName', label: 'Conductor 1' },
  { value: 'secondDriverName', label: 'Conductor 2' },
  { value: 'thirdDriverName', label: 'Conductor 3' },
  { value: 'cabinCrewList', label: 'Tripulantes' },
  { value: 'tripCircuitStatus', label: 'Orden en Circuito' },
  { value: 'active', label: 'Estado' },
  { value: 'ticketsSold', label: 'Boletos Vendidos' },
  { value: 'type', label: 'Tipo de Itinerario' },
  { value: 'routeName', label: 'Ruta' },
  { value: 'id', label: 'ID' },
];

export const COMMERCIAL_STATUS_OPTIONS = [
  {
    value: 'ON_TRIP',
    label: 'En viaje',
  },
  {
    value: 'PROGRAMMED',
    label: 'Programado',
  },
  {
    value: 'NOT_PROGRAMMABLE',
    label: 'No Programar',
  },
  {
    value: 'STANDBY',
    label: 'Retén',
  },
  {
    value: 'AVAILABLE',
    label: 'Disponible',
  },
];

export const COMMERCIAL_STATUS = {
  ON_TRIP: {
    value: 'ON_TRIP',
    label: 'En viaje',
    color: 'info',
  },
  PROGRAMMED: {
    value: 'PROGRAMMED',
    label: 'Programado',
    color: 'primary',
  },
  NOT_PROGRAMMABLE: {
    value: 'NOT_PROGRAMMABLE',
    label: 'No Programar',
    color: 'danger',
  },
  STANDBY: {
    value: 'STANDBY',
    label: 'Retén',
    color: 'warning',
  },
  AVAILABLE: {
    value: 'AVAILABLE',
    label: 'Disponible',
    color: 'success',
  },
};

export const STATUS_EVENT_TYPE = {
  ITINERARY: {
    value: 'ITINERARY',
    label: 'Itinerario',
    color: 'info',
  },
  MAINTENANCE: {
    value: 'MAINTENANCE',
    label: 'Mantenimiento',
    color: 'danger',
  },
  RETENTION: {
    value: 'RETENTION',
    label: 'Retén',
    color: 'warning',
  },
};

export const END_DATE_SOURCE = {
  ESTIMATED: {
    value: 'ESTIMATED',
    label: 'Llegada estimada',
    color: 'info',
  },
  SCHEDULED: {
    value: 'SCHEDULED',
    label: 'Programado',
    color: 'info',
  },
  ACTUAL_DELIVERY: {
    value: 'ACTUAL_DELIVERY',
    label: 'Entrega real',
    color: 'success',
  },
  ESTIMATED_COMPLETION: {
    value: 'ESTIMATED_COMPLETION',
    label: 'Término estimado',
    color: 'info',
  },
  GRACE_PERIOD: {
    value: 'GRACE_PERIOD',
    label: 'Estimado por sistema',
    color: 'warning',
  },
  NONE: {
    value: 'NONE',
    label: 'Sin fin resuelto',
    color: 'secondary',
  },
};

export const MAINTENANCE_STAY_STATUS_OPTIONS = [
  {
    value: 'OPERATIONAL',
    label: 'Operativo',
  },
  {
    value: 'EXTENDED_MAINTENANCE',
    label: 'Mantenimiento Extendido',
  },
  {
    value: 'NOT_SCHEDULED',
    label: 'No Programar',
  },
  {
    value: 'LOGISTICS',
    label: 'Logística',
  },
];

export const MAINTENANCE_STAY_STATUS = {
  OPERATIONAL: {
    value: 'OPERATIONAL',
    label: 'Operativo',
  },
  EXTENDED_MAINTENANCE: {
    value: 'EXTENDED_MAINTENANCE',
    label: 'Mantenimiento Extendido',
  },
  NOT_SCHEDULED: {
    value: 'NOT_SCHEDULED',
    label: 'No Programar',
  },
  LOGISTICS: {
    value: 'LOGISTICS',
    label: 'Logística',
  },
};

export const REGISTERED_BUS_FLEET_OPTIONS = {
  AVAILABLE: { value: 'available', label: 'Disponible', order: 3 },
  NOT_PROGRAMMABLE: {
    value: 'notProgrammable',
    label: 'No Programable',
    order: 4,
  },
  ON_TRIP: { value: 'onTrip', label: 'En Viaje', order: 2 },
  PROGRAMMED: { value: 'programmed', label: 'Programado', order: 0 },
  STANDBY: { value: 'standby', label: 'Retén', order: 1 },
  TOTAL_FLEET: { value: 'totalFleet', label: 'Flota Total', order: 5 },
};

export const CREDIT_NOTE_MOTIVES = {
  CLIENT_REQUEST: {
    value: 'CLIENT_REQUEST',
    label: 'Solicitud del Cliente',
    color: 'info',
  },
  SERVICE_CLOSURE: {
    value: 'SERVICE_CLOSURE',
    label: 'Cierre de Servicio',
    color: 'warning',
  },
  ERROR: { value: 'ERROR', label: 'Error', color: 'error' },
  COMERCIAL_SCALE: {
    value: 'COMERCIAL_SCALE',
    label: 'Incovenientes en Escala Comercial',
    color: 'warning',
  },
  MECHANICAL_FAILURE: {
    value: 'MECHANICAL_FAILURE',
    label: 'Falla Mecanica',
    color: 'warning',
  },
  LATENESS: {
    value: 'LATENESS',
    label: 'Inpuntualidad',
    color: 'info',
  },
  LEGAL_ABANDONMENT: {
    value: 'LEGAL_ABANDONMENT',
    label: 'Abandono Legal',
    color: 'danger',
  },
  LATE_SHIPPING: {
    value: 'LATE_SHIPPING',
    label: 'Envío Tardío',
    color: 'warning',
  },
  OTHERS: { value: 'OTHERS', label: 'Otros', color: 'default' },
};

export const CREDIT_NOTE_MOTIVES_TICKET = {
  CLIENT_REQUEST: {
    value: 'CLIENT_REQUEST',
    label: 'Solicitud del Cliente',
    color: 'info',
  },
  SERVICE_CLOSURE: {
    value: 'SERVICE_CLOSURE',
    label: 'Cierre de Servicio',
    color: 'warning',
  },
  ERROR: { value: 'ERROR', label: 'Error', color: 'error' },
  COMERCIAL_SCALE: {
    value: 'COMERCIAL_SCALE',
    label: 'Incovenientes en Escala Comercial',
    color: 'warning',
  },
  MECHANICAL_FAILURE: {
    value: 'MECHANICAL_FAILURE',
    label: 'Falla Mecanica',
    color: 'warning',
  },
  LATENESS: {
    value: 'LATENESS',
    label: 'Inpuntualidad',
    color: 'info',
  },
  OTHERS: { value: 'OTHERS', label: 'Otros', color: 'default' },
};

export const TICKET_BOARDING_TIME_STATUS = {
  EARLY: {
    value: 'EARLY',
    label: 'Temprano',
    color: 'success',
  },
  LATE: { value: 'LATE', label: 'Tarde', color: 'danger' },
};

export const TICKET_BOARDING_STATUS = {
  UNBOARDED: { value: 'UNBOARDED', label: 'Desembarco', color: 'warning' },
  BOARDED: { value: 'BOARDED', label: 'Embarcado', color: 'success' },
  UNREGISTERED: {
    value: 'UNREGISTERED',
    label: 'No Embarcado',
    color: 'info',
  },
  DISEMBARKED: {
    value: 'DISEMBARKED',
    label: 'Embarcado y Desembarcado',
    color: 'primary',
  },
  BOARDED_TEMPORAL: {
    value: 'BOARDED_TEMPORAL',
    label: 'Embarcado Temporal',
    color: 'success',
  },
};

export const TICKET_SENSITIVE_TOOLBAR_STATUS = [
  TICKET_BOARDING_STATUS.UNREGISTERED.value,
  TICKET_BOARDING_STATUS.UNBOARDED.value,
];

export const TICKET_REASSINGMENT_ACCEPT_MERGE = {
  YES: { value: 'YES', label: 'Si', color: 'success' },
  NO: {
    value: 'NO',
    label: 'No',
    color: 'danger',
  },
  EMAIL: { value: 'EMAIL', label: 'Correo', color: 'success' },
  WHATSAPP: { value: 'WHATSAPP', label: 'WhatsApp', color: 'success' },
  NO_ANSWER: {
    value: 'NO_ANSWER',
    label: 'No Contesta',
    color: 'warning',
  },
  NO_DATA: {
    value: 'NO_DATA',
    label: 'Sin Datos',
    color: 'danger',
  },
  CALLBACK: { value: 'CALLBACK', label: 'Devolver Llamada', color: 'warning' },
  AGENCY_DERIVED: {
    value: 'AGENCY_DERIVED',
    label: 'Derivado a Agencia',
    color: 'info',
  },
  NOT_APPLICABLE: {
    value: 'NOT_APPLICABLE',
    label: 'No Aplica',
    color: 'info',
  },
};

export const TICKET_REASSINGMENT_NEGOTIATION = {
  DISCOUNT_10: {
    value: 'DISCOUNT_10',
    label: '10% de Descuento',
    color: 'info',
  },
  DISCOUNT_20: {
    value: 'DISCOUNT_20',
    label: '20% de Descuento',
    color: 'info',
  },
  DIFFERENCE_DISCOUNT: {
    value: 'DIFFERENCE_DISCOUNT',
    label: 'Descuento de Diferencia',
    color: 'info',
  },
  DIFFERENCE_REFUND: {
    value: 'DIFFERENCE_DISCOUNT',
    label: 'Devolución de Diferencia',
    color: 'info',
  },
  FULL_REFUND: {
    value: 'FULL_REFUND',
    label: 'Devolución Total',
    color: 'info',
  },
  NOT_APPLICABLE: {
    value: 'NOT_APPLICABLE',
    label: 'No Aplica',
    color: 'info',
  },
};

export const TICKET_REASSINGMENT_RETURN_TYPE = {
  BANK_DEPOSIT: {
    value: 'BANK_DEPOSIT',
    label: 'Depósito Bancario',
    color: 'info',
  },
  AGENCY: {
    value: 'AGENCY',
    label: 'Agencia',
    color: 'info',
  },
  NOT_APPLICABLE: {
    value: 'NOT_APPLICABLE',
    label: 'No Aplica',
    color: 'info',
  },
};

export const INCIDENT_SCOPE_TYPE = {
  ITINERARY: { value: 'ITINERARY', label: 'Itinerario' },
  AGENCY: { value: 'AGENCY', label: 'Agencia' },
  ADMINISTRATIVE: { value: 'ADMINISTRATIVE', label: 'Administrativo' },
};

export const INCIDENT_RECORD_TYPE = {
  ARRIVAL: {
    value: 'ARRIVAL',
    label: 'Llegada',
    incidentScopeType: INCIDENT_SCOPE_TYPE.ITINERARY.value,
  },
  DEPARTURE: {
    value: 'DEPARTURE',
    label: 'Salida',
    incidentScopeType: INCIDENT_SCOPE_TYPE.ITINERARY.value,
  },
  AGENCY: {
    value: 'AGENCY',
    label: 'Agencia',
    incidentScopeType: INCIDENT_SCOPE_TYPE.AGENCY.value,
  },
  DAILY: {
    value: 'DAILY',
    label: 'Diario',
    incidentScopeType: INCIDENT_SCOPE_TYPE.ADMINISTRATIVE.value,
  },
  WEEKLY: {
    value: 'WEEKLY',
    label: 'Semanal',
    incidentScopeType: INCIDENT_SCOPE_TYPE.ADMINISTRATIVE.value,
  },
  MONTHLY: {
    value: 'MONTHLY',
    label: 'Mensual',
    incidentScopeType: INCIDENT_SCOPE_TYPE.ADMINISTRATIVE.value,
  },
};

export const PAYMENT_TYPE = {
  CASH: { value: 'CASH', label: 'Contado', color: 'success' },
  CREDIT: { value: 'CREDIT', label: 'Crédito', color: 'warning' },
};

export const BILL_PROCESS_ORIGIN = {
  TICKET: { value: 'TICKET', label: 'Pasajes' },
  EXCESS_BAGGAGE: { value: 'EXCESS_BAGGAGE', label: 'Excesos' },
  PARCEL: { value: 'PARCEL', label: 'Encomiendas' },
  MANUAL_VOUCHER: { value: 'MANUAL_VOUCHER', label: 'Contratos' },
};

export const BILLING_REPORT_DETAIL_STATUS = {
  PENDING: { value: 'PENDING', label: 'PENDIENTE', color: 'warning' },
  PROCESSING: {
    value: 'PROCESSING',
    label: 'Procesando',
    color: 'info',
  },
  FINISHED: {
    value: 'FINISHED',
    label: 'Finalizado',
    color: 'success',
  },
  ERROR: {
    value: 'ERROR',
    label: 'Error',
    color: 'danger',
  },
};

export const ITEM_CONTENT_TYPE = {
  NO_DECLARATION: {
    value: 'NO_DECLARATION',
    label: 'No declara',
    default: false,
  },
  PERSONAL: {
    value: 'PERSONAL',
    label: 'Articulos personales',
    default: false,
  },
  PERISHABLE: {
    value: 'PERISHABLE',
    label: 'perecible',
    default: false,
  },
  NOT_APPLICABLE: {
    value: 'NOT_APPLICABLE',
    label: 'No aplica',
    default: true,
  },
};

export const DEBOUNCE_BAGGAGE_PRICE = 800;

export const BAGGAGE_MANIFEST_MODULE = {
  DEFAULT: { value: 'DEFAULT', label: 'Equipaje', default: true },
  BOARDING: { value: 'BOARDING', label: 'Embarque', default: false },
  DISMISSAL: { value: 'DISMISSAL', label: 'Desembarque', default: false },
  CHANGE_ITINERARY: {
    value: 'CHANGE_ITINERARY',
    label: 'Cambio de Itinerario',
    default: false,
  },
};

export const BAGGAGE_MANIFEST_ACTIONS = {
  DISMISS: { value: 'DISMISS', label: 'Bajar del Manifiesto' },
  REPORT_ISSUE: { value: 'REPORT_ISSUE', label: 'Reportar Incidencia' },
  DELIVER: { value: 'DELIVER', label: 'Entregar Equipaje' },
  CHANGE_ITINERARY: { value: 'CHANGE_ITINERARY', label: 'Cambiar Itinerario' },
};

export const NEW_BAGGAGE_ITEM_STATUS = {
  IN_ORIGIN_AGENCY: {
    value: 'IN_ORIGIN_AGENCY',
    label: 'Registrado',
  },
  ON_ITINERARY: { value: 'ON_ITINERARY', label: 'Despachado' },
  AGENCY_STOP: { value: 'AGENCY_STOP', label: 'En escala comercial' },
  DELIVERED: { value: 'DELIVERED', label: 'Entregado' },
  NOT_ARRIVED: { value: 'NOT_ARRIVED', label: 'No llego' },
  CLOSED: { value: 'CLOSED', label: 'Cerrado' },
  VOIDED: { value: 'VOIDED', label: 'Devuelto al cliente', color: 'danger' },
  RECEIVED_AT_DESTINATION: {
    value: 'RECEIVED_AT_DESTINATION',
    label: 'Sin reclamar',
  },
  UNCLAIMED: { value: 'UNCLAIMED', label: 'Abandono' },
  UNCLAIMED_DEPURATED: {
    value: 'UNCLAIMED_DEPURATED',
    label: 'Abandono - Depurado',
  },
  SEIZED: { value: 'SEIZED', label: 'Incautado', color: 'danger' },
};

export const ITEM_INCIDENT_TYPE = {
  WRONG_DESTINATION: { value: 'WRONG_DESTINATION', label: 'Error en destino' },
  DAMAGED: { value: 'DAMAGED', label: 'Dañado' },
  NOT_COLLECTED: { value: 'NOT_COLLECTED', label: 'No recogido' },
};

export const REPORT_ISSUE_OPTIONS = {
  NOT_ARRIVED: {
    value: 'NOT_ARRIVED',
    label: 'Equipaje no arribó',
    isIncident: false,
  },
  SEIZED: { value: 'SEIZED', label: 'Incautado', isIncident: false },
  ...Object.values(ITEM_INCIDENT_TYPE).reduce((acc, incidentType) => {
    acc[incidentType.value] = {
      value: incidentType.value,
      label: `Incidencia - ${incidentType.label}`,
      isIncident: true,
    };
    return acc;
  }, {}),
};

export const BAGGAGE_STATUS = {
  ACTIVE: { value: 'ACTIVE', label: 'Activo', color: 'success' },
  VOIDED: { value: 'VOIDED', label: 'Anulado', color: 'danger' },
};

export const SUPPLIER_TYPE = {
  FEDDING: {
    value: 'FEDDING',
    label: 'Alimentación',
    color: 'info',
  },
  HOUSING: {
    value: 'HOUSING',
    label: 'Hospedaje',
    color: 'primary',
  },
};

export const BILLING_TYPE = {
  INVOICE: {
    value: 'INVOICE',
    label: 'Factura',
    color: 'primary',
  },
  TICKET: {
    value: 'TICKET',
    label: 'Boleta',
    color: 'success',
  },
};

export const CREDIT_TIME = {
  ONE_WEEK: {
    value: 'ONE_WEEK',
    label: '1 semana',
    color: 'success',
  },
  FIFTEEN_DAYS: {
    value: 'FIFTEEN_DAYS',
    label: '15 días',
    color: 'warning',
  },
  THIRTY_DAYS: {
    value: 'THIRTY_DAYS',
    label: '30 días',
    color: 'error',
  },
};

export const FOOD_PUBLIC_TYPE = {
  PASSENGER: {
    value: 'PASSENGER',
    label: 'Pasajeros',
    color: 'success',
  },
  DRIVER: {
    value: 'DRIVER',
    label: 'Conductores',
    color: 'warning',
  },
  SAB: {
    value: 'SAB',
    label: 'Tripulantes SAB',
    color: 'info',
  },
};

export const ITINERARY_FOOD_INVOICE_BILLING_STATUS = {
  PENDING_INVOICING: {
    value: 'PENDING_INVOICING',
    label: 'Pendiente de Facturación',
    color: 'warning',
  },
  INVOICED: {
    value: 'INVOICED',
    label: 'Facturado',
    color: 'success',
  },
};

export const TRIP_MANAGEMENT_COST_CENTER_ID = 88;

export const EXCESS_BAGGAGE_INCREMENTAL_PRICE = [
  {
    value: 5,
    label: 'S/ 5.00',
  },
  {
    value: 10,
    label: 'S/ 10.00',
  },
  {
    value: 15,
    label: 'S/ 15.00',
  },
  {
    value: 20,
    label: 'S/ 20.00',
  },
  {
    value: 25,
    label: 'S/ 25.00',
  },
  {
    value: 30,
    label: 'S/ 30.00',
  },
  {
    value: 35,
    label: 'S/ 35.00',
  },
  {
    value: 40,
    label: 'S/ 40.00',
  },
];

export const EXCESS_BAGGAGE_ACCOUNTING_STATUS = {
  ACTIVE: { value: 'ACTIVE', label: 'Activo', color: 'success' },
  VOIDED: { value: 'VOIDED', label: 'Anulado', color: 'danger' },
  VOIDED_WITH_CREDIT_NOTE: {
    value: 'ACTIVE',
    label: 'Activo',
    color: 'success',
  },
};

export const BOLETA_VOUCHER_TYPE_ID = 1;

export const FACTURA_VOUCHER_TYPE_ID = 2;

export const RECIBO_HONORARIOS_VOUCHER_TYPE_ID = 67;

export const ITINERARY_CHANGE_ROUTE_STATUS = {
  PENDING: { value: 'PENDING', label: 'PENDIENTE', color: 'info' },
  PROCESSING: {
    value: 'PROCESSING',
    label: 'Procesando',
    color: 'warning',
  },
  ERROR: {
    value: 'ERROR',
    label: 'Error',
    color: 'danger',
  },
  SUCCESSFULL: {
    value: 'SUCCESSFULL',
    label: 'Terminado',
    color: 'success',
  },
  CONFLICT: {
    value: 'CONFLICT',
    label: 'Conflicto',
    color: 'warning',
  },
};

export const ITINERARY_COUNTER_REPORT_STATUS = {
  PENDING: { value: 'PENDING', label: 'Pendiente', color: 'warning' },
  PROCESSING: { value: 'PROCESSING', label: 'Procesando', color: 'info' },
  COMPLETED: { value: 'COMPLETED', label: 'Completado', color: 'success' },
  FAILED: { value: 'FAILED', label: 'Fallido', color: 'danger' },
};

export const SEAT_RELEASE_STATUS_FILTERS = [
  { key: 'all', label: 'Todos' },
  { key: 'ACTIVE', label: 'Activos' },
  { key: 'USED', label: 'Usados' },
];

export const PREVENTIVE_TASK_REPEAT_TYPE = {
  DAYS: {
    value: 0,
    label: 'Cada N Días',
    code: 'DAYS',
  },
  WEEKLY: {
    value: 1,
    label: 'Semanal',
    code: 'WEEKLY',
  },
  MONTHLY_DAYS: {
    value: 2,
    label: 'Día fijo del Mes',
    code: 'MONTHLY_DAYS',
  },
  MONTHLY_RULE: {
    value: 3,
    label: 'Mensual',
    code: 'MONTHLY_RULE',
  },
};

export const PREVENTIVE_TASK_RESOURCE_SCHEDULE_MODE = {
  SAME_DATE: {
    value: 1,
    label: 'Todos los recursos en la misma fecha',
    code: 'SAME_DATE',
    description:
      'Todos los recursos asociados se proyectan y ejecutan en la misma fecha.',
  },
  RESOURCE_BASED: {
    value: 2,
    label: 'Cada recurso según su última ejecución',
    code: 'RESOURCE_BASED',
    description:
      'Cada recurso se proyecta desde su propia última ejecución completada.',
  },
};

export const PREVENTIVE_TASK_MONTHLY_TYPE = {
  NTH_WEEKDAY_OF_MONTH: {
    value: 'NTH_WEEKDAY_OF_MONTH',
    label: 'Día de semana específico del mes',
    code: 'NTH_WEEKDAY_OF_MONTH',
    description: 'Ejemplo: tercer martes del mes.',
  },
  LAST_WEEKDAY_OF_MONTH: {
    value: 'LAST_WEEKDAY_OF_MONTH',
    label: 'Último día de semana del mes',
    code: 'LAST_WEEKDAY_OF_MONTH',
    description: 'Ejemplo: último viernes del mes.',
  },
};

export const PREVENTIVE_TASK_WEEK_ORDER = {
  FIRST: {
    value: 1,
    label: 'Primero',
    code: 'FIRST',
  },
  SECOND: {
    value: 2,
    label: 'Segundo',
    code: 'SECOND',
  },
  THIRD: {
    value: 3,
    label: 'Tercero',
    code: 'THIRD',
  },
  FOURTH: {
    value: 4,
    label: 'Cuarto',
    code: 'FOURTH',
  },
  LAST: {
    value: -1,
    label: 'Último',
    code: 'LAST',
  },
};

export const PREVENTIVE_TASK_WEEKDAY = {
  MONDAY: {
    value: 1,
    label: 'Lunes',
    code: 'MONDAY',
  },
  TUESDAY: {
    value: 2,
    label: 'Martes',
    code: 'TUESDAY',
  },
  WEDNESDAY: {
    value: 3,
    label: 'Miércoles',
    code: 'WEDNESDAY',
  },
  THURSDAY: {
    value: 4,
    label: 'Jueves',
    code: 'THURSDAY',
  },
  FRIDAY: {
    value: 5,
    label: 'Viernes',
    code: 'FRIDAY',
  },
  SATURDAY: {
    value: 6,
    label: 'Sábado',
    code: 'SATURDAY',
  },
  SUNDAY: {
    value: 7,
    label: 'Domingo',
    code: 'SUNDAY',
  },
};

export const PREVENTIVE_TASK_ASSIGNEE_SCOPE = {
  AREA: {
    value: 'AREA',
    label: 'Área',
    code: 'AREA',
  },
  ROLE: {
    value: 'ROLE',
    label: 'Rol / Cargo',
    code: 'ROLE',
  },
  PERSON: {
    value: 'PERSON',
    label: 'Personal específico',
    code: 'PERSON',
  },
};

export const RESOURCE_EXECUTION_MODE = {
  SAME_DATE: {
    value: 'SAME_DATE',
    label: 'Todos con la misma fecha',
  },
  GROUPED: {
    value: 'GROUPED',
    label: 'Agrupar recursos por fecha',
  },
  RESOURCE_BASED: {
    value: 'RESOURCE_BASED',
    label: 'Fecha individual por recurso',
  },
};

export const PREVENTIVE_TASK_EXECUTION_STATUS = {
  PENDING: { value: 'PENDING', label: 'Pendiente', color: 'info' },
  EXTENDED: { value: 'EXTENDED', label: 'Extendido', color: 'warning' },
  DONE: { value: 'DONE', label: 'Realizado', color: 'success' },
  ADVANCE: { value: 'ADVANCE', label: 'Adelantado', color: 'primary' },
  POSTPONE: { value: 'POSTPONE', label: 'Postergado', color: 'info' },
};

export const PREVENTIVE_TASK_PRIORITY = {
  LOW: {
    value: 'LOW',
    label: 'Baja',
    color: 'secondary',
    hexColor: COLOR.darkGray,
    icon: 'fa fa-level-down',
  },
  MEDIUM: {
    value: 'MEDIUM',
    label: 'Media',
    color: 'warning',
    hexColor: COLOR.orange,
    icon: 'fa fa-arrows-h',
  },
  HIGH: {
    value: 'HIGH',
    label: 'Alta',
    color: 'danger',
    hexColor: COLOR.orange,
    icon: 'fa fa-level-up',
  },
  URGENT: {
    value: 'URGENT',
    label: 'URGENTE',
    color: 'danger',
    hexColor: COLOR.red,
    icon: 'fa fa-level-up',
  },
};

export const PREVENTIVE_TASK_STATUS_ACTIVITY = {
  OVERDUE: {
    value: 'OVERDUE',
    label: 'Vencido',
    color: 'danger',
  },
  DUE_SOON: { value: 'DUE_SOON', label: 'Por Vencer', color: 'warning' },
  IN_RANGE: { value: 'IN_RANGE', label: 'Dentro del Rango', color: 'info' },
  POSTPONE: { value: 'POSTPONE', label: 'Postergado', color: 'info' },
  EXTENDED: { value: 'EXTENDED', label: 'Extendido', color: 'success' },
};

export const MAX_PAYMENT_METHODS = 3;

export const EXCLUSIVE_TRANSACTION_CODES = [
  TRANSACTION_TYPE_OTHER,
  TRANSACTION_TYPE_PAYMENT_ON_ARRIVAL,
];

export const EXPENSE_AUTHORIZER_USER_TYPE = {
  PRINCIPAL: { value: 'PRINCIPAL', label: 'Principal', color: 'info' },
  SECONDARY: { value: 'SECONDARY', label: 'Secundario', color: 'info' },
};

export const POLICY_NUMBER = 'N°6665527';

export const PAYMENT_METHODS = {
  QR: {
    value: 20,
    label: 'Billetera Digital',
    transactionCode: TRANSACTION_TYPE_INTERNET,
  },
};

export const MECHANIC_EMPLOYEE_TYPE = {
  OPERATION: { value: 'OPERATION', label: 'Operativo', color: 'info' },
  ADMINISTRATIVE: {
    value: 'ADMINISTRATIVE',
    label: 'Administrativo',
    color: 'info',
  },
  SUPPLIER: {
    value: 'SUPPLIER',
    label: 'Proveedor',
    color: 'info',
  },
};

export const SUPPLIER_ASSIGNED_SERVICE_STATUS = {
  PENDING: {
    value: 'PENDING',
    label: 'Pendiente',
    color: 'warning',
  },
  ATTENDED: {
    value: 'ATTENDED',
    label: 'Atendido',
    color: 'success',
  },
};

export const MIGRATION_STATUS = {
  PENDING: {
    value: 'PENDING',
    label: 'Pendiente',
    color: 'info',
  },
  PROCESSING: {
    value: 'PROCESSING',
    label: 'Procesando',
    color: 'primary',
  },
  SUCCESS: {
    value: 'SUCCESS',
    label: 'Migrado',
    color: 'success',
  },
  ERROR: {
    value: 'ERROR',
    label: 'No Migrado',
    color: 'danger',
  },
};

export const TOLL_LIQUIDATION_DETAIL_BUTTON = {
  DETAIL: { value: 'detail', label: 'Detalle Peajes' },
  PROVIA_DETAIL: { value: 'provia-detail', label: 'Detalle Provías' },
};

export const TOLL_LIQUIDATION_DETAIL_DROPDOWN_OPTIONS = [
  { value: 'header', label: 'Detalle' },
  {
    value: TOLL_LIQUIDATION_DETAIL_BUTTON.DETAIL.value,
    label: 'Detalle Peajes',
  },
  {
    value: TOLL_LIQUIDATION_DETAIL_BUTTON.PROVIA_DETAIL.value,
    label: 'Detalle Provías',
  },
];

export const BOARDED_AT_OTHER_LOCATION_OPTIONS = [
  { value: true, label: 'Sí' },
  { value: false, label: 'No' },
];